var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 147.879,
    cy: -15.811,
    r: 147.879,
    id: "gradient-1",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgba(218, 105, 85, 1)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgba(165, 55, 36, 1)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "M 264.618 174.725 C 264.979 176.988 268.848 178.339 276.744 178.631 C 284.64 178.859 295.877 178.175 311.335 176.432 L 310.465 179.325 C 315.333 176.76 319.036 175.674 321.702 175.802 C 324.293 175.902 323.664 177.773 326.098 180.274 C 328.459 182.838 332.393 187.867 335.956 190.659 C 339.455 193.352 343.093 195.086 346.99 196.236 C 349.692 194.858 352.488 193.114 355.255 191.015 C 358.088 188.88 360.717 186.379 363.651 183.523 C 362.087 179.781 361.448 176.851 362.022 174.752 C 362.549 172.553 364.882 170.281 366.715 170.746 C 368.446 171.202 370.251 173.237 372.25 177.253 C 374.879 176.724 376.582 176.888 377.35 177.609 C 378.109 178.33 377.85 179.744 376.684 181.716 C 377.711 182.272 378.516 182.802 379.081 183.295 C 379.683 183.787 380.081 183.787 379.914 184.709 C 379.581 185.531 378.748 186.708 377.276 188.259 C 380.044 189.208 380.108 187.109 380.812 188.022 C 381.478 188.916 381.812 191.216 379.979 191.837 C 378.146 192.494 376.748 192.202 373.916 193.872 C 371.047 195.579 366.687 196.792 363.855 200.735 C 361.05 204.714 360.485 212.891 358.051 215.848 C 355.589 218.741 353.451 218.841 349.22 218.084 C 344.99 217.263 337.696 212.864 332.828 211.157 C 327.931 209.441 323.294 210.299 320.193 207.935 C 317.064 205.572 315.13 201.985 314.269 197.03 L 307.901 197.979 C 308.697 202.807 308.428 206.092 307.373 208.1 C 306.207 209.971 309.03 209.049 301.097 209.642 C 293.007 210.199 279.447 210.829 259.648 211.513 C 261.286 199.266 262.952 187.009 264.618 174.725 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M 307.965 182.537 C 310.039 181.46 312.001 180.538 314.371 179.781 C 316.666 179.023 319.462 177.28 321.498 177.846 C 323.433 178.303 323.035 179.817 325.83 182.51 C 328.496 185.102 334.364 191.052 337.761 193.781 C 341.093 196.473 342.926 198.636 345.823 198.636 C 348.554 198.472 351.553 195.679 354.82 193.288 C 358.088 190.851 361.689 187.894 365.622 184.28 C 364.456 180.83 363.919 178.266 364.021 176.459 C 364.114 174.588 365.086 173.438 366.15 173.374 C 367.085 173.274 369.445 174.031 369.917 175.775 C 370.315 177.381 369.853 179.945 368.649 183.331 C 371.278 180.475 373.213 178.859 374.314 178.366 C 375.379 177.81 375.712 179.389 375.314 180.438 C 374.916 181.524 373.786 182.838 371.917 184.645 C 374.018 183.76 375.443 183.431 376.35 183.66 C 377.082 183.851 377.415 184.873 376.98 185.823 C 376.545 186.617 375.545 187.602 373.981 188.652 C 376.119 188.752 377.378 189.081 378.044 189.637 C 378.646 190.167 378.211 191.116 377.646 191.736 C 377.045 192.138 376.813 191.317 374.249 192.822 C 371.546 194.438 364.456 197.522 361.689 200.936 C 358.856 204.221 359.125 209.578 357.588 212.307 C 355.987 214.935 355.293 216.377 352.423 216.377 C 349.359 216.122 344.49 212.8 340.029 211.358 C 335.429 209.943 329.727 209.122 326.034 207.643 C 322.461 205.964 320.1 204.221 318.536 201.666 C 316.796 199.001 315.963 195.752 315.898 191.773 C 315.037 193.315 313.899 194.301 312.63 194.994 C 311.307 195.615 309.706 195.816 307.965 195.579 C 307.938 193.023 307.873 190.723 307.901 188.551 C 307.873 186.288 307.938 184.417 307.965 182.537 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M 265.951 178.795 C 272.144 180.073 278.549 180.803 285.639 180.967 C 292.674 181.095 299.94 180.666 307.799 179.681 C 306.299 182.51 305.466 185.795 305.3 189.674 C 305.105 193.543 306.605 199.658 306.734 202.679 C 306.771 205.608 306.336 207.114 305.568 207.215 L 261.888 208.492 C 263.221 198.608 264.581 188.716 265.951 178.795 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(100, 242, 135)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M 270.08 184.253 C 269.746 185.366 270.478 186.58 271.718 186.945 C 272.977 187.338 274.282 186.717 274.615 185.594 C 274.976 184.481 274.245 183.267 272.977 182.902 C 271.718 182.51 270.413 183.13 270.08 184.253 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M 274.745 188.323 C 274.384 189.437 275.143 190.659 276.383 191.015 C 277.642 191.408 278.947 190.787 279.28 189.674 C 279.641 188.551 278.882 187.338 277.642 186.972 C 276.383 186.58 275.078 187.21 274.745 188.323 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "M 282.946 185.074 C 282.612 186.188 283.344 187.401 284.612 187.766 C 285.843 188.159 287.139 187.538 287.509 186.416 C 287.842 185.302 287.111 184.089 285.843 183.724 C 284.612 183.331 283.307 183.952 282.946 185.074 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M 286.944 193.251 C 286.574 194.365 287.342 195.588 288.574 195.98 C 289.842 196.336 291.137 195.752 291.48 194.593 C 291.841 193.479 291.073 192.293 289.842 191.901 C 288.574 191.545 287.278 192.138 286.944 193.251 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "M 297.006 190.559 C 296.636 191.672 297.376 192.886 298.635 193.251 C 299.903 193.644 301.208 193.023 301.542 191.901 C 301.875 190.787 301.134 189.573 299.903 189.208 C 298.635 188.816 297.339 189.437 297.006 190.559 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "M 292.804 183.824 C 292.443 184.937 293.211 186.151 294.442 186.516 C 295.71 186.909 297.006 186.288 297.339 185.165 C 297.709 184.052 296.941 182.838 295.71 182.473 C 294.442 182.081 293.137 182.701 292.804 183.824 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "M 298.07 202.058 C 297.709 203.172 298.441 204.385 299.709 204.787 C 300.977 205.143 302.273 204.55 302.606 203.436 C 302.939 202.314 302.208 201.1 300.977 200.707 C 299.709 200.352 298.404 200.936 298.07 202.058 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "M 289.712 202.715 C 289.342 203.829 290.073 205.042 291.341 205.408 C 292.609 205.8 293.905 205.179 294.238 204.057 C 294.609 202.943 293.84 201.73 292.609 201.365 C 291.341 200.972 290.045 201.593 289.712 202.715 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "M 279.178 203.071 C 278.845 204.194 279.576 205.408 280.845 205.773 C 282.076 206.128 283.381 205.535 283.742 204.422 C 284.075 203.299 283.344 202.086 282.076 201.73 C 280.808 201.337 279.512 201.921 279.178 203.071 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "M 280.178 195.652 C 279.808 196.765 280.548 197.979 281.807 198.38 C 283.075 198.736 284.38 198.143 284.714 197.03 C 285.047 195.907 284.316 194.693 283.075 194.301 C 281.807 193.945 280.511 194.529 280.178 195.652 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "M 270.913 199.987 C 270.552 201.1 271.283 202.323 272.551 202.715 C 273.819 203.071 275.115 202.487 275.448 201.365 C 275.781 200.251 275.05 199.028 273.819 198.636 C 272.551 198.28 271.246 198.873 270.913 199.987 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "M 265.414 203.966 C 265.081 205.079 265.812 206.293 267.081 206.658 C 268.312 207.05 269.617 206.43 269.978 205.307 C 270.311 204.194 269.58 202.98 268.312 202.615 C 267.053 202.222 265.785 202.843 265.414 203.966 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "M 223.863 196.373 L 282.946 82.075 C 286.278 82.366 290.24 85.192 294.84 90.547 C 299.505 95.902 304.466 103.659 310.372 114.072 C 320.267 114.172 327.366 115.587 332.3 118.443 C 337.123 121.3 339.39 125.37 339.224 131.028 C 344.389 114.729 346.388 100.305 345.592 86.736 C 344.592 73.2 340.159 60.912 333.957 50.629 C 327.737 40.247 319.267 31.935 308.437 25.199 C 310.168 20.567 310.9 17.314 310.372 15.08 C 309.706 12.748 307.105 11.039 305.401 12.09 C 303.772 13.24 302.236 16.263 300.671 21.651 C 294.775 16.493 287.981 13.076 280.15 11.269 C 272.218 9.429 262.286 9.068 253.826 10.711 C 245.458 12.189 237.766 14.456 229.963 20.567 C 222.03 26.678 214.403 35.351 206.674 47.081 C 213.607 43.926 220.235 43.335 227.195 45.175 C 234.063 47.048 243.125 52.6 247.726 58.284 C 252.261 63.836 254.427 70.407 254.353 78.259 C 257.352 78.128 260.555 78.259 264.35 78.522 C 268.089 78.752 272.014 79.212 276.55 79.902 L 221.938 191.179 C 222.567 192.885 223.197 194.628 223.863 196.372 L 223.863 196.373 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    d: "M 214.699 41.331 C 219.096 34.53 224.326 28.878 230.528 24.378 C 236.729 19.811 243.958 16.099 251.586 14.259 C 259.083 12.353 267.978 11.828 275.448 13.175 C 282.909 14.489 289.573 17.314 295.969 21.914 C 290.073 24.444 284.473 28.912 278.78 35.319 C 273.051 41.725 265.646 53.947 262.119 60.189 C 258.518 66.3 256.954 70.177 257.417 71.951 C 256.519 63.376 254.02 56.904 249.651 52.009 C 245.227 47.146 237.192 44.682 231.361 42.974 C 225.492 41.134 220.031 40.674 214.699 41.331 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(0, 247, 251)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "M 260.185 75.795 C 262.249 67.417 264.979 60.124 268.515 53.651 C 271.949 47.179 275.948 41.791 281.28 37.224 C 286.574 32.526 295.775 24.871 300.403 26.284 C 304.976 27.762 306.401 36.009 308.437 45.701 C 310.27 55.36 311.464 72.806 312.038 83.713 C 312.603 94.522 312.603 103.066 312.038 109.965 C 306.706 99.878 301.569 92.354 296.506 86.999 C 291.378 81.644 287.842 79.771 281.807 77.964 C 275.643 76.091 268.617 75.368 260.185 75.795 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(1, 255, 5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    d: "M 315.935 109.965 C 316 91.631 315.537 76.748 314.537 64.296 C 313.501 51.844 309.372 41.232 309.835 36.14 C 310.233 31.146 312.797 31.31 316.768 34.234 C 320.665 37.093 328.866 45.109 333.133 53.093 C 337.326 60.978 340.76 69.816 341.991 81.249 C 343.195 92.617 342.426 105.657 340.057 120.907 C 337.595 118.343 334.364 116.107 330.365 114.337 C 326.293 112.466 321.535 111.051 315.935 109.965 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(136, 4, 251)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "M 193.003 198.545 C 217.236 176.395 237.896 158.59 256.251 143.869 C 274.476 129.121 287.546 121.072 301.736 111.343 C 315.768 101.523 332.032 89.627 339.992 86.177 C 347.795 82.826 350.192 85.619 348.859 91.368 C 347.489 97.085 341.862 106.451 331.958 120.086 C 334.66 123.536 337.298 125.635 339.992 126.657 C 342.658 127.606 345.157 126.62 347.758 125.836 C 350.22 125.014 352.617 123.435 354.959 121.464 C 350.618 130.928 345.953 137.234 341.093 141.14 C 336.095 144.919 329.625 144.992 325.561 144.134 C 321.535 143.112 318.666 140.319 316.962 135.391 C 310.937 140.976 302.208 147.876 290.647 156.454 C 278.947 164.996 262.656 176.496 247.661 186.251 C 232.564 195.916 217.337 205.079 201.074 214.141 L 190.513 219.07 C 191.337 212.243 192.17 205.408 193.003 198.545 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "M 195.243 200.479 C 209.497 187.465 223.465 175.282 237.655 163.29 C 251.789 151.234 266.784 138.914 279.808 129.121 C 292.841 119.201 304.541 111.672 315.037 104.772 C 325.497 97.775 338.955 87.689 341.658 87.82 C 344.055 88.083 341.427 95.147 330.032 105.858 C 318.434 116.436 289.98 138.612 273.449 150.969 C 256.852 163.153 244.856 170.025 231.564 179.16 C 218.235 188.259 205.934 196.865 194.141 205.371 C 194.502 203.765 194.873 202.122 195.243 200.479 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(6, 254, 175)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "M 194.41 206.494 C 209.868 197.395 225.029 187.995 240.423 178.038 C 255.917 168.017 273.412 156.162 286.213 146.89 C 298.737 137.499 306.568 130.271 315.602 122.286 C 324.562 114.273 334.531 105 339.724 99.286 C 344.722 93.504 346.758 89.89 345.823 88.083 C 347.193 89.2 347.425 91.073 346.656 93.833 C 345.823 96.494 345.287 98.826 341.093 104.508 C 336.66 110.257 329.829 119.657 321.128 127.999 C 312.464 136.212 304.374 142.719 289.508 153.725 C 274.411 164.732 248.124 182.838 231.823 193.352 C 215.495 203.664 202.639 210.956 192.475 215.492 C 193.105 212.508 193.743 209.514 194.41 206.494 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(126, 192, 240)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "M 329.727 123.636 C 330.726 125.799 332.393 127.314 334.725 128.3 C 337.058 129.185 341.121 129.678 343.593 129.386 C 345.99 128.984 347.619 128.099 348.859 126.356 C 345.287 132.735 341.695 137.07 338.057 139.498 C 334.392 141.797 329.93 141.442 326.968 140.584 C 323.895 139.662 321.498 137.663 319.767 134.314 C 323.062 130.764 326.395 127.214 329.727 123.636 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(6, 254, 175)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    d: "M 251.151 174.159 C 252.15 176.267 256.288 176.395 263.915 174.424 C 271.579 172.352 282.14 168.51 296.377 162.405 L 296.377 165.389 C 300.273 161.583 303.504 159.448 306.068 158.854 C 308.604 158.261 308.567 160.105 311.631 161.839 C 314.732 163.518 319.832 167.333 324.099 168.975 C 328.199 170.518 332.263 171.239 336.299 171.138 C 338.492 169.067 340.631 166.575 342.695 163.783 C 344.694 160.926 346.629 157.768 348.489 154.191 C 345.86 151.033 344.527 148.441 344.361 146.269 C 344.222 143.933 345.796 141.277 347.656 141.076 C 349.387 140.976 351.757 142.528 354.885 145.713 C 357.292 144.426 358.949 144.07 359.884 144.627 C 360.754 145.083 361.022 146.497 360.42 148.733 C 361.615 148.898 362.448 149.263 363.188 149.555 C 363.78 149.756 364.447 149.783 364.419 150.668 C 364.317 151.526 363.919 152.904 362.947 154.812 C 365.854 154.939 365.317 152.904 366.215 153.561 C 367.15 154.255 368.112 156.326 366.585 157.476 C 365.021 158.626 363.586 158.754 361.355 161.154 C 359.125 163.618 355.32 166.019 353.756 170.618 C 352.256 175.218 354.117 183.231 352.654 186.744 C 351.155 190.194 349.156 190.915 344.888 191.38 C 340.594 191.837 332.328 189.701 327.163 189.473 C 321.961 189.245 317.795 191.38 314.102 189.993 C 310.437 188.615 307.54 185.759 305.235 181.259 L 299.403 183.988 C 301.569 188.323 302.402 191.609 301.902 193.845 C 301.301 196.007 303.837 194.237 296.377 197.13 C 288.805 199.987 275.976 204.449 257.25 210.792 C 255.223 198.608 253.187 186.388 251.151 174.159 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    d: "M 294.942 169.204 C 296.608 167.588 298.339 166.146 300.273 164.732 C 302.106 163.253 304.466 160.89 306.466 160.826 C 308.373 160.689 308.604 162.24 312.038 164.075 C 315.472 165.882 322.599 169.696 326.728 171.44 C 330.662 173.046 333.161 174.588 335.891 173.767 C 338.557 172.845 340.427 169.268 342.926 166.082 C 345.361 162.733 347.925 158.982 350.618 154.355 C 348.526 151.398 347.193 149.098 346.758 147.319 C 346.36 145.484 346.86 144.134 347.888 143.769 C 348.859 143.312 351.192 143.541 352.192 144.992 C 353.025 146.497 353.451 148.898 353.219 152.576 C 354.987 149.062 356.19 147.027 357.19 146.205 C 358.153 145.411 358.717 146.698 358.754 147.876 C 358.717 148.998 357.921 150.668 356.718 152.904 C 358.523 151.398 359.754 150.769 360.689 150.668 C 361.42 150.604 362.087 151.626 361.92 152.576 C 361.818 153.497 361.05 154.647 359.884 156.162 C 361.92 155.733 363.318 155.532 364.086 155.925 C 364.752 156.226 364.78 157.312 364.317 158.033 C 363.818 158.718 363.382 157.732 361.355 160.032 C 359.189 162.332 353.423 167.36 351.757 171.44 C 349.989 175.346 351.858 180.502 351.192 183.495 C 350.424 186.388 350.285 188.122 347.452 188.852 C 344.49 189.51 338.798 187.703 334.096 187.602 C 329.292 187.438 323.562 188.524 319.6 188.058 C 315.667 187.502 313.038 186.48 310.668 184.481 C 308.234 182.409 306.475 179.553 305.235 175.775 C 304.8 177.445 304.17 178.795 303.069 179.817 C 301.977 180.767 300.542 181.387 298.774 181.688 C 297.941 179.252 297.274 177.116 296.645 175.017 C 296.006 172.918 295.442 170.974 294.942 169.204 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    d: "M 253.65 177.682 C 259.981 177.116 266.349 175.966 273.116 174.095 C 279.882 172.124 286.639 169.76 293.905 166.511 C 293.276 169.724 293.507 172.945 294.47 176.788 C 295.405 180.602 298.737 185.896 299.709 188.852 C 300.607 191.572 300.671 193.215 299.903 193.516 L 258.518 207.251 C 256.917 197.395 255.288 187.538 253.65 177.682 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(100, 242, 135)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    d: "M 259.185 181.688 C 259.185 182.866 260.249 183.824 261.555 183.824 C 262.887 183.824 263.952 182.866 263.952 181.688 C 263.952 180.538 262.887 179.58 261.555 179.58 C 260.249 179.58 259.185 180.538 259.185 181.688 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63",
    d: "M 264.85 184.253 C 264.85 185.43 265.914 186.388 267.219 186.388 C 268.515 186.388 269.58 185.43 269.58 184.253 C 269.58 183.103 268.515 182.145 267.219 182.145 C 265.914 182.145 264.85 183.103 264.85 184.253 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65",
    d: "M 271.746 178.795 C 271.746 179.982 272.81 180.931 274.115 180.931 C 275.448 180.931 276.513 179.982 276.513 178.795 C 276.513 177.609 275.448 176.66 274.115 176.66 C 272.819 176.66 271.746 177.609 271.746 178.795 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67",
    d: "M 277.984 185.494 C 277.984 186.644 279.049 187.602 280.345 187.602 C 281.65 187.602 282.714 186.644 282.714 185.494 C 282.714 184.317 281.65 183.358 280.345 183.358 C 279.049 183.358 277.984 184.317 277.984 185.494 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69",
    d: "M 286.806 180.009 C 286.806 181.196 287.842 182.145 289.175 182.145 C 290.48 182.145 291.545 181.196 291.545 180.009 C 291.545 178.859 290.48 177.91 289.175 177.91 C 287.842 177.91 286.806 178.859 286.806 180.009 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path71",
    d: "M 280.808 174.789 C 280.808 175.939 281.844 176.888 283.177 176.888 C 284.473 176.888 285.547 175.939 285.547 174.789 C 285.547 173.602 284.482 172.653 283.177 172.653 C 281.844 172.653 280.808 173.602 280.808 174.789 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73",
    d: "M 291.212 190.723 C 291.212 191.901 292.276 192.859 293.572 192.859 C 294.905 192.859 295.979 191.901 295.979 190.723 C 295.979 189.573 294.905 188.615 293.572 188.615 C 292.276 188.615 291.212 189.573 291.212 190.723 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path75",
    d: "M 283.409 193.744 C 283.409 194.931 284.473 195.88 285.778 195.88 C 287.083 195.88 288.138 194.931 288.138 193.744 C 288.138 192.558 287.083 191.645 285.778 191.645 C 284.473 191.645 283.409 192.558 283.409 193.744 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path77",
    d: "M 273.449 197.093 C 273.449 198.28 274.513 199.229 275.818 199.229 C 277.114 199.229 278.179 198.28 278.179 197.093 C 278.179 195.916 277.114 194.958 275.818 194.958 C 274.513 194.958 273.449 195.916 273.449 197.093 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path79",
    d: "M 272.181 189.738 C 272.181 190.888 273.245 191.837 274.578 191.837 C 275.883 191.837 276.948 190.888 276.948 189.738 C 276.948 188.551 275.883 187.602 274.578 187.602 C 273.245 187.602 272.181 188.551 272.181 189.738 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path81",
    d: "M 264.618 196.537 C 264.618 197.723 265.683 198.672 266.979 198.672 C 268.312 198.672 269.385 197.723 269.385 196.537 C 269.385 195.35 268.312 194.401 266.979 194.401 C 265.683 194.401 264.618 195.35 264.618 196.537 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path83",
    d: "M 260.555 201.894 C 260.555 203.071 261.619 204.029 262.915 204.029 C 264.22 204.029 265.285 203.071 265.285 201.894 C 265.285 200.707 264.22 199.758 262.915 199.758 C 261.619 199.758 260.555 200.707 260.555 201.894 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path85",
    strokeLinejoin: "round",
    d: "M 178.378 179.516 C 178.378 210.108 185.774 239.969 208.6 239.969 C 231.425 239.969 280.141 206.822 280.141 176.231 C 280.141 145.676 260.249 120.479 237.424 120.479 C 214.635 120.479 178.378 148.962 178.378 179.516 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.9978,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path87",
    strokeLinejoin: "round",
    d: "M 217.208 181.424 C 221.642 181.424 225.242 186.498 225.242 192.759 C 225.242 199.01 221.642 204.093 217.208 204.093 C 212.774 204.093 209.183 199.019 209.183 192.759 C 209.183 186.498 212.774 181.424 217.208 181.424",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(181, 243, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path89",
    strokeLinejoin: "round",
    d: "M 218.865 178.996 C 218.263 175.546 218.633 170.481 219.966 163.682 C 221.364 156.819 224.067 145.083 226.899 138.256 C 229.528 131.357 232.629 126.192 236.063 122.651 C 241.691 123.399 246.587 124.686 250.753 126.493 C 254.853 128.263 257.889 130.207 261.018 133.328 C 264.146 136.376 267.479 141.049 269.617 144.791 C 271.644 148.405 272.847 151.918 273.217 155.204 C 264.452 159.146 256.39 163.618 248.522 168.875 C 240.561 174.132 233.425 179.781 226.362 186.352 C 225.696 184.253 224.761 182.738 223.567 181.46 C 222.262 180.21 220.697 179.389 218.865 178.996 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(254, 245, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path91",
    strokeLinejoin: "round",
    d: "M 215.533 179.252 C 215.097 176.696 215.468 172.453 216.366 166.411 C 217.263 160.269 218.532 150.276 221.068 143.148 C 223.53 135.984 226.992 129.614 231.324 123.764 C 224.159 124.686 217.467 127.113 211.099 131.421 C 204.666 135.592 196.909 144.727 193.077 149.19 C 189.208 153.561 187.412 156.518 187.81 157.933 C 190.911 162.103 194.243 166.11 198.075 170.217 C 201.907 174.26 205.971 178.266 210.534 182.245 C 209.664 182.701 209.664 182.701 210.534 182.245 C 211.33 181.716 212.996 180.767 215.533 179.252 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(238, 74, 28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path93",
    strokeLinejoin: "round",
    d: "M 208.035 184.444 C 206.471 183.495 203.999 181.259 200.269 177.353 C 196.539 173.438 191.744 168.154 185.875 161.218 C 183.811 164.011 182.543 167.561 181.71 171.859 C 180.84 176.231 180.914 181.296 181.146 186.909 C 181.275 192.366 181.877 200.315 182.812 204.687 C 183.747 208.985 184.774 211.586 186.412 212.599 L 207.202 198.937 C 206.073 196.409 205.739 193.945 205.832 191.545 C 205.934 189.108 206.665 186.744 208.035 184.444 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(0, 135, 245)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path95",
    strokeLinejoin: "round",
    d: "M 228.824 187.995 C 232.231 184.746 237.424 180.867 244.921 176.231 C 252.391 171.531 261.647 166.247 273.217 160.105 C 276.078 164.704 277.281 169.596 276.809 175.409 C 276.244 181.095 274.217 187.602 270.181 194.301 C 266.081 201.036 260.388 207.872 252.687 215.328 C 247.254 211.65 242.588 208.328 238.562 205.243 C 234.489 202.058 231.157 199.366 228.565 196.765 C 228.491 195.223 228.491 193.872 228.565 192.366 C 228.63 190.851 228.63 189.437 228.824 187.995 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(0, 253, 245)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97",
    strokeLinejoin: "round",
    d: "M 207.767 201.136 L 185.875 215.884 C 186.838 220.557 188.606 224.564 191.67 227.913 C 194.669 231.235 199.204 234.52 203.601 235.862 C 207.905 237.112 212.302 237.012 217.199 235.57 L 216.097 207.415 C 213.765 207.014 211.867 206.293 210.534 205.243 C 209.136 204.194 208.165 202.779 207.767 201.136 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(92, 252, 24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path99",
    strokeLinejoin: "round",
    d: "M 220.531 206.886 C 220.799 207.151 221.531 206.685 222.734 205.508 C 223.928 204.258 225.594 202.387 227.732 199.758 L 248.253 217.527 C 243.227 222.784 238.46 226.799 233.823 229.556 C 229.158 232.284 224.733 233.699 220.531 233.927 L 220.531 206.886 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(70, 23, 240)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path101",
    strokeLinejoin: "round",
    d: "M 147.388 175.081 C 147.619 174.196 147.351 176.952 146.324 183.851 C 145.259 190.659 142.186 209.387 141.353 215.821 C 140.427 222.127 141.325 217.828 141.353 221.899 C 141.288 225.969 141.288 231.855 141.223 239.905 L 178.748 239.741 C 179.211 228.342 178.878 217.5 177.378 206.457 C 175.842 195.451 173.509 184.873 170.01 174.196 C 162.485 174.488 154.95 174.789 147.388 175.081 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path103",
    strokeLinejoin: "round",
    d: "M 148.758 176.13 C 148.517 179.16 148.017 184.116 147.258 191.152 C 146.425 198.216 144.426 210.007 144.093 218.184 C 143.658 226.334 143.954 233.17 144.991 239.448 L 176.943 238.855 C 177.212 231.463 177.082 223.906 176.175 215.656 C 175.249 207.278 173.148 196.637 171.815 189.802 C 170.381 183.066 169.251 178.403 168.048 175.546 C 161.615 175.738 155.182 175.939 148.758 176.13 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(0, 253, 245)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path105",
    strokeLinejoin: "round",
    d: "M 141.853 107.209 C 131.393 106.388 122.128 106.023 113.566 106.123 C 105.031 106.15 97.506 106.78 90.841 107.729 C 88.708 106.15 86.342 105.365 83.876 105 C 81.277 104.608 78.045 104.708 75.846 105.822 C 73.48 106.972 70.014 110.029 70.581 111.571 C 71.28 112.958 74.213 113.908 79.744 114.3 C 78.245 115.45 77.312 116.408 76.945 117.029 C 76.512 117.686 76.745 118.014 77.512 118.142 C 76.579 119.429 76.112 120.378 76.112 121.136 C 76.112 121.829 76.579 122.286 77.512 122.514 C 76.645 123.965 76.512 125.014 77.245 126.064 C 77.945 126.986 79.245 128.564 81.677 128.263 C 84.143 127.907 88.708 125.014 91.374 124.156 C 93.706 123.171 94.04 122.815 96.368 123.07 C 98.7 123.372 100.172 125.078 105.531 125.799 C 111.002 126.493 121.832 126.849 128.265 126.885 C 134.494 126.821 139.391 126.228 142.954 125.242 C 141.427 127.707 141.288 129.349 142.427 130.171 C 143.593 130.992 145.99 130.992 149.887 130.171 C 147.592 132.434 145.685 135.263 144.056 138.649 C 142.454 141.998 141.122 145.877 140.187 150.413 C 138.595 150.413 137.16 150.705 136.021 150.933 C 134.892 151.134 134.355 150.741 133.263 152.055 C 132.023 153.269 129.69 156.29 128.829 158.59 C 127.894 160.826 127.496 164.047 127.996 165.453 C 128.459 166.767 130.56 166.968 131.597 166.803 C 132.523 166.603 133.124 165.781 133.522 164.339 C 135.096 166.082 136.16 166.767 137.123 166.539 C 137.956 166.183 138.558 165.033 138.789 162.697 C 139.354 164.704 140.261 165.526 141.853 164.896 C 143.352 164.239 145.389 162.368 147.953 159.146 C 146.888 163.39 146.287 166.803 146.018 169.532 C 145.685 172.224 145.824 174.095 146.287 175.282 C 150.183 176.724 154.256 177.317 158.486 177.189 C 162.716 176.952 167.011 176.003 171.51 174.196 C 170.445 165.453 170.51 157.011 172.084 148.505 C 173.546 139.899 177.915 129.477 180.414 123.335 C 182.812 117.129 186.94 115.021 186.773 111.571 C 186.477 108.03 183.978 104.973 179.007 102.281 C 179.341 99.943 180.414 97.479 182.34 94.884 C 184.246 92.223 189.439 89.791 190.374 86.703 C 191.207 83.483 188.439 77.734 187.338 76.025 C 186.172 74.383 184.876 74.448 183.441 76.584 C 182.377 75.533 182.978 74.317 185.107 73.298 C 187.273 72.247 190.837 71.031 196.205 70.013 C 192.41 69.684 190.874 69.093 191.476 68.37 C 192.142 67.45 199.204 66.202 199.806 65.381 C 200.241 64.625 193.938 64.756 194.271 63.738 C 194.604 62.522 201.805 60.124 201.472 58.81 C 200.806 57.43 191.337 56.838 191.476 55.787 C 191.707 54.637 201.5 53.421 202.87 52.502 C 203.999 51.516 199.538 51.22 198.973 50.333 C 198.436 49.38 200.334 48.033 199.538 47.048 C 198.575 45.931 193.077 45.274 193.706 44.321 C 194.308 43.335 203.999 42.547 203.407 41.594 C 202.666 40.641 194.41 38.703 189.541 38.834 C 184.506 38.801 177.276 40.575 174.009 41.857 C 170.714 43.171 169.51 44.584 170.149 46.489 C 169.612 42.415 169.612 38.637 170.149 35.023 C 170.649 31.376 171.315 28.123 173.176 24.904 C 175.009 21.585 177.48 18.399 180.942 15.343 L 172.343 13.7 C 170.177 15.737 168.381 18.793 166.817 22.998 C 165.151 27.236 163.679 33.906 162.92 38.571 C 162.087 43.072 161.846 46.719 162.087 49.775 C 159.717 48.855 158.153 49.085 157.116 50.333 C 156.089 51.614 156.348 54.44 155.987 57.167 C 155.552 59.73 155.052 62.686 154.617 65.906 C 150.489 68.929 148.156 70.999 147.12 72.477 C 146.12 73.791 147.018 73.791 148.786 74.383 C 150.489 74.941 153.349 75.697 157.385 76.288 C 157.32 79.114 157.348 82.629 157.116 87.229 C 156.987 91.763 156.589 97.019 156.283 103.358 C 152.183 102.901 148.989 103.002 146.555 103.659 C 144.121 104.279 142.556 105.466 141.853 107.209 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path107",
    strokeLinejoin: "round",
    d: "M 170.047 46.325 C 171.112 44.616 173.583 43.302 177.313 42.251 C 181.146 41.101 188.81 40.411 192.475 40.181 C 196.002 39.951 199.538 40.542 198.436 41.068 C 197.14 41.462 186.773 42.284 185.477 42.908 C 184.172 43.434 190.744 44.025 190.642 44.551 C 190.309 45.011 183.58 45.438 184.339 45.832 C 185.144 46.128 194.576 46.489 195.539 46.785 C 196.307 46.949 189.245 47.015 189.504 47.508 C 189.809 48 197.002 49.183 197.242 49.906 C 197.335 50.497 190.309 51.089 190.541 51.417 C 190.744 51.582 198.769 51.384 198.705 51.713 C 198.501 52.009 191.207 52.961 189.809 53.553 C 188.375 54.046 190.605 54.374 190.207 54.9 C 189.671 55.294 185.913 55.623 187.144 56.247 C 188.338 56.838 196.835 57.857 197.872 58.547 C 198.769 59.138 193.503 59.434 193.142 59.927 C 192.67 60.189 195.835 60.551 195.706 60.879 C 195.474 61.208 193.836 61.996 192.475 62.226 C 191.105 62.359 190.642 61.931 187.875 61.832 C 185.079 61.668 181.044 61.339 175.777 61.109 C 174.712 58.054 174.25 55.853 174.25 54.506 C 174.314 53.06 176.008 53.487 175.879 52.994 C 175.546 52.436 172.843 52.173 172.547 51.713 C 172.25 51.089 173.944 50.629 173.778 50.202 C 173.417 49.807 170.945 49.709 170.612 49.413 C 170.214 48.986 171.649 48.493 171.584 48.066 C 171.38 47.573 170.251 47.245 169.983 46.949 C 169.677 46.621 169.751 46.456 170.047 46.325 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {},
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path109",
    strokeLinejoin: "round",
    d: "M 177.415 66.432 C 177.943 67.45 178.646 68.436 179.507 69.52 C 180.312 70.604 180.673 72.543 182.414 72.806 C 184.08 72.937 188.504 70.966 189.411 70.572 C 190.143 70.079 186.94 70.539 187.005 70.177 C 186.94 69.816 189.374 68.765 189.411 68.436 C 189.374 68.042 186.644 67.943 187.144 67.779 C 187.606 67.516 189.245 67.188 192.17 66.925 C 189.809 66.76 187.412 66.695 184.978 66.596 C 182.441 66.53 180.007 66.432 177.415 66.432 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path111",
    strokeLinejoin: "round",
    d: "M 176.175 66.596 L 170.714 66.498 C 170.677 67.877 170.112 69.356 169.011 70.802 C 167.78 72.214 165.651 74.416 164.012 75.27 C 162.318 76.058 160.384 75.96 159.255 75.73 C 158.088 75.368 157.681 74.711 157.153 73.496 C 156.589 72.214 156.089 69.454 155.783 68.502 C 155.385 67.516 155.015 67.253 154.821 67.713 C 151.183 69.553 149.221 70.966 148.786 72.083 C 148.286 73.134 150.683 73.528 152.257 74.153 C 153.849 74.645 155.82 75.105 158.283 75.401 L 158.116 77.635 C 158.421 78.654 159.347 79.147 161.282 78.982 C 163.087 78.785 166.919 77.767 169.177 76.682 C 171.343 75.565 173.25 72.51 174.25 72.313 C 175.11 72.05 175.212 73.528 174.814 75.105 C 174.342 76.584 172.315 78.917 171.676 81.216 C 170.982 83.451 171.214 85.389 170.714 88.543 C 170.01 91.598 168.918 97.808 168.048 99.681 C 167.178 101.359 166.252 100.967 165.614 99.122 C 164.984 97.217 164.549 90.876 163.92 88.707 C 163.05 86.407 161.615 87.065 160.884 85.849 C 160.152 84.6 159.68 83.089 159.486 81.315 L 158.449 80.921 C 158.153 84.14 157.986 87.524 157.949 90.941 C 157.783 94.424 157.616 98.005 157.949 101.423 C 158.088 104.809 158.218 108.879 159.653 110.586 C 161.152 112.037 163.818 111.809 166.752 110.421 C 169.612 108.943 174.176 104.644 176.582 102.08 C 178.711 99.384 178.545 96.821 180.211 94.752 C 181.914 92.616 185.107 91.499 186.607 89.758 C 188.004 87.984 188.504 86.209 188.606 84.172 C 188.504 82.004 187.542 78.193 186.607 77.174 C 185.607 76.123 184.413 76.386 182.876 77.963 C 182.247 76.222 181.84 75.17 181.673 74.316 C 181.442 73.495 181.442 73.166 181.673 73.199 C 180.109 72.016 178.878 71.031 177.98 69.881 C 177.045 68.732 176.443 67.68 176.175 66.596 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path113",
    strokeLinejoin: "round",
    d: "M 171.75 76.715 C 171.278 77.865 170.177 78.785 168.446 79.475 C 166.613 80.165 164.281 80.625 161.18 80.855 C 160.652 81.873 160.782 82.826 161.448 83.713 C 162.152 84.469 164.345 84.732 165.216 86.013 C 165.845 87.294 165.382 91.368 166.012 91.5 C 166.65 91.467 168.344 88.182 169.177 86.473 C 169.918 84.699 169.844 82.958 170.381 81.381 C 170.779 79.705 171.278 78.194 171.75 76.715 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path115",
    strokeLinejoin: "round",
    d: "M 156.348 66.399 C 155.848 64.559 156.089 63.376 156.422 61.077 C 156.681 58.645 157.218 54.144 157.885 52.403 C 158.449 50.662 159.319 50.892 159.986 50.826 C 160.513 50.596 160.587 50.465 161.346 51.713 C 162.05 52.994 164.049 55.393 164.253 58.382 C 164.318 61.307 162.781 66.793 161.985 69.126 C 161.05 71.327 160.18 72.083 159.255 71.656 C 158.218 71.163 156.783 68.14 156.348 66.399 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(84, 237, 237)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path117",
    strokeLinejoin: "round",
    d: "M 170.418 16.953 C 169.983 17.511 169.483 18.004 169.177 18.694 C 168.751 19.253 168.511 20.008 168.215 20.698 L 173.713 22.768 C 174.342 21.783 174.916 20.961 175.416 20.304 C 175.879 19.647 176.277 19.023 176.61 18.694 C 174.546 18.136 172.482 17.544 170.418 16.953 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path119",
    strokeLinejoin: "round",
    d: "M 167.983 22.111 C 167.585 22.768 167.382 23.261 167.113 23.951 C 166.817 24.608 166.715 25.101 166.548 25.791 L 171.214 27.368 C 171.38 26.546 171.75 25.856 171.945 25.298 C 172.111 24.739 172.482 24.115 172.676 23.787 L 167.983 22.111 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path121",
    strokeLinejoin: "round",
    d: "M 141.955 108.916 C 138.354 108.258 133.263 107.994 126.524 107.866 C 119.629 107.766 107.938 107.893 101.736 108.258 C 95.573 108.423 91.707 108.879 89.874 109.271 C 88.608 107.537 86.709 106.552 84.043 106.315 C 81.277 106.086 75.446 106.944 73.88 107.866 C 72.247 108.715 72.68 110.421 74.413 111.343 C 76.146 112.101 81.544 111.9 84.176 112.885 C 86.642 113.844 89.108 116.408 89.408 117.157 C 89.641 117.686 86.475 116.244 85.842 116.764 C 85.176 117.257 85.209 119.365 85.542 120.542 C 85.776 121.628 86.376 123.399 87.475 123.7 C 88.541 123.928 90.241 122.249 92.04 122.085 C 93.74 121.857 95.006 121.829 97.775 122.386 C 100.533 122.842 104.198 124.521 108.364 125.115 C 112.464 125.571 116.296 125.443 122.026 125.471 C 127.626 125.443 134.161 125.242 141.89 125.014 C 141.455 123.965 141.186 122.057 141.223 119.429 C 141.26 116.7 141.455 113.287 141.955 108.916 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path123",
    strokeLinejoin: "round",
    d: "M 84.709 117.522 C 83.643 116.499 82.643 115.915 81.577 115.751 C 80.477 115.514 78.678 115.943 78.378 116.271 C 77.978 116.536 78.511 117.23 79.344 117.585 C 80.178 117.814 82.21 118.014 83.143 118.179 C 83.976 118.279 84.276 118.443 84.176 118.544 C 84.343 118.215 84.509 117.887 84.709 117.522 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path125",
    strokeLinejoin: "round",
    d: "M 82.91 118.9 C 81.544 118.635 80.477 118.635 79.578 118.9 C 78.545 119.064 77.712 119.858 77.478 120.378 C 77.245 120.871 77.112 121.729 78.378 121.92 C 79.611 122.021 81.577 121.665 84.643 120.971 L 84.409 119 C 83.91 118.964 83.41 118.936 82.91 118.9 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path127",
    strokeLinejoin: "round",
    d: "M 85.009 121.92 C 82.21 121.829 80.344 122.121 79.411 122.678 C 78.445 123.143 78.345 124.649 79.111 125.306 C 79.811 125.9 82.044 126.657 83.376 126.557 C 84.676 126.356 85.576 125.671 86.575 124.357 C 85.976 123.928 85.509 123.472 85.309 123.107 C 85.043 122.678 84.943 122.286 85.009 121.92 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path129",
    strokeLinejoin: "round",
    d: "M 156.154 126.684 C 153.118 128.3 150.452 131.12 148.017 135.163 C 145.518 139.206 143.519 144.262 141.658 150.705 C 143.686 151.462 145.389 152.311 146.759 153.005 C 148.119 153.762 149.054 154.355 149.684 155.04 C 151.424 152.183 153.182 149.427 155.348 146.37 C 157.422 143.212 160.819 139.498 162.217 137.006 C 163.512 134.478 164.614 133.255 163.586 131.585 C 162.55 129.778 160.115 128.263 156.154 126.684 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path131",
    d: "M 133.356 153.789 C 131.328 157.212 130.162 159.904 129.727 161.875 C 129.329 163.81 130.329 165.453 130.792 165.553 C 131.19 165.425 131.227 163.974 132.162 161.976 C 132.995 159.904 135.225 155.569 135.892 153.89 C 136.456 152.247 136.456 151.626 135.892 152.147 L 133.356 153.789 Z",
    fillRule: "evenodd",
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path133",
    d: "M 138.622 153.297 C 137.725 153.725 136.188 155.697 135.688 157.44 C 135.059 159.046 135.022 161.811 135.188 163.062 C 135.29 164.175 135.929 164.668 136.456 164.403 C 136.891 164.111 137.058 162.824 137.854 161.319 C 138.521 159.703 140.659 156.39 140.788 155.04 C 140.853 153.662 139.492 152.877 138.622 153.297 Z",
    fillRule: "evenodd",
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path135",
    d: "M 143.325 154.848 C 142.353 155.633 141.621 158.553 141.26 160.068 C 140.992 161.446 141.094 162.989 141.557 163.062 C 141.89 162.989 142.519 161.382 143.325 160.132 C 144.019 158.791 145.926 156.29 145.953 155.432 C 145.926 154.419 144.019 154.091 143.325 154.848 Z",
    fillRule: "evenodd",
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path137",
    strokeLinejoin: "round",
    d: "M 149.489 128.692 C 148.388 129.021 147.388 129.121 146.351 128.984 C 145.259 128.82 144.019 130.171 143.426 127.834 C 142.788 125.343 142.353 118.306 142.658 114.601 C 142.852 110.887 142.454 107.729 144.787 106.023 C 147.12 104.252 150.887 103.759 156.45 104.279 C 156.885 107.464 157.82 109.7 158.986 111.243 C 160.152 112.657 161.68 113.251 163.586 113.15 C 165.345 113.086 167.345 112.164 169.844 110.659 C 172.278 109.08 175.083 106.552 178.248 103.431 C 180.479 104.051 182.173 105 183.339 106.415 C 184.441 107.83 185.579 109.637 185.209 111.708 C 184.672 113.616 182.441 115.058 180.812 118.179 C 179.146 121.3 177.045 125.115 175.416 130.234 C 173.546 135.327 171.482 141.076 170.51 148.368 C 169.612 155.633 169.381 163.646 169.946 173.174 C 167.15 174.524 164.049 175.245 160.152 175.473 C 156.218 175.711 151.988 175.309 146.953 174.424 C 147.055 169.66 147.49 165.818 148.517 162.368 C 149.489 158.982 150.757 157.604 152.821 154.154 C 154.719 150.504 158.051 144.362 160.254 141.049 C 162.513 137.727 164.179 135.792 165.752 134.214 C 167.048 132.571 168.65 132.041 168.381 131.22 C 167.946 130.298 165.253 130.134 163.883 129.085 C 162.55 127.935 161.68 125.407 160.254 124.649 C 158.551 123.828 156.45 123.764 154.589 124.458 C 152.757 125.115 151.054 126.52 149.489 128.692 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(49, 202, 19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path139",
    strokeLinejoin: "round",
    d: "M 91.341 207.507 C 84.376 206.849 77.312 206.557 69.648 206.494 C 62.017 206.357 51.82 206.594 45.722 207.178 C 39.457 207.771 35.292 208.593 32.726 209.907 C 32.16 209.286 31.793 208.894 31.26 208.729 C 30.727 208.492 30.227 208.492 29.761 208.729 L 29.494 205.28 C 31.427 205.508 32.76 205.28 33.993 204.586 C 35.126 203.801 37.325 202.25 36.225 200.972 C 35.026 199.621 29.894 196.966 26.995 196.665 C 23.963 196.309 19.431 197.814 18.531 199.065 C 17.598 200.315 18.598 201.894 21.53 204.057 C 20.83 204.951 20.497 205.864 20.53 206.822 C 20.564 207.707 20.93 208.629 21.763 209.578 C 18.531 209.642 16.165 211.978 14.532 216.441 C 12.933 220.977 12.4 226.334 12.033 236.419 C 11.5 246.439 11.333 259.517 11.533 276.173 C 7.934 277.788 5.735 280.608 4.569 284.788 C 3.369 288.922 3.403 295.922 4.802 300.95 C 6.135 305.842 8.501 311.035 12.8 314.384 C 16.998 317.734 24.962 320.298 30.26 320.928 C 35.559 321.448 40.091 320.362 44.223 317.67 C 44.456 317.998 45.122 318.299 46.222 318.555 C 47.355 318.82 48.721 318.956 50.687 319.084 C 50.121 324.049 51.454 329.634 55.186 336.105 C 58.851 342.575 64.549 353.682 72.413 357.624 C 80.144 361.403 92.574 362.617 101.338 359.003 C 110.067 355.224 117.5 347.631 124.266 335.612 C 134.763 337.446 145.157 338.669 156.218 339.39 C 167.215 340.011 179.248 339.655 189.874 339.719 C 200.371 339.682 211.164 339.883 219.068 339.554 C 226.76 339.253 232.49 338.505 236.257 337.647 C 234.823 343.105 236.257 348.097 240.423 352.632 C 244.523 357.132 253.918 362.58 261.147 364.688 C 268.413 366.687 276.883 367.088 283.575 364.852 C 290.212 362.452 296.673 355.781 300.542 350.917 C 304.272 345.988 305.966 341.06 305.772 335.776 C 310.705 335.384 316.768 335.94 324.229 337.319 C 331.661 338.733 340.223 340.832 350.192 344.017 C 348.387 340.175 347.693 336.789 347.693 333.869 C 347.721 330.848 348.591 328.411 350.424 326.312 L 339.455 325.263 C 343.954 321.484 347.156 317.113 349.692 312.021 C 352.09 306.764 354.358 299.207 353.923 294.808 C 353.358 290.437 350.887 287.909 346.925 286.193 C 342.889 284.386 337.456 283.702 330.227 284.131 C 331.791 282.451 332.791 279.558 333.226 275.324 C 333.624 271.016 333.457 265.632 332.726 258.796 C 336.058 256.989 338.622 253.968 340.695 249.862 C 342.658 245.59 344.592 238.362 344.685 234.027 C 344.62 229.592 343.287 226.27 340.955 224.198 C 338.594 222.2 335.225 221.406 330.726 221.963 C 329.625 220.457 327.431 219.307 323.997 218.513 C 320.563 217.691 316.037 217.235 310.27 217.135 C 312.436 213.493 312.436 210.728 310.27 208.729 C 308.002 206.722 303.032 204.814 297.043 205.28 C 290.906 205.672 281.548 209.679 274.347 210.956 C 267.081 212.143 258.417 211.549 254.15 212.343 C 249.855 213.001 248.022 213.913 248.651 215.1 C 245.393 214.999 235.757 214.972 219.235 214.871 C 202.537 214.735 179.84 214.671 149.887 214.543 C 148.286 210.4 146.759 207.114 145.157 204.55 C 143.519 201.958 141.853 200.215 140.159 199.202 C 141.825 189.701 143.454 181.789 144.926 174.953 C 146.324 168.081 147.684 162.797 148.888 158.59 C 142.519 157.869 137.058 158.161 132.226 159.84 C 127.33 161.419 126.793 160.233 119.962 168.218 C 113.066 176.267 103.699 189.108 91.341 207.507 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path141",
    strokeLinejoin: "round",
    d: "M 144.657 160.497 C 140.455 160.169 136.891 160.561 133.328 161.674 C 129.727 162.697 128.857 161.775 123.794 167.032 C 118.629 172.288 107.67 186.151 103.004 193.023 C 98.274 199.786 95.906 204.385 95.772 207.315 C 95.539 207.58 96.867 208.136 99.774 208.857 C 102.671 209.578 107.031 210.6 113.001 211.778 C 113.834 207.479 115.861 202.642 118.731 197.157 C 121.665 191.545 125.997 185.065 130.458 178.896 C 134.827 172.681 139.391 166.676 144.657 160.497 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(229, 247, 200)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path143",
    strokeLinejoin: "round",
    d: "M 118.731 211.093 C 120.795 211.057 122.665 211.285 124.192 211.778 C 125.691 212.207 126.997 212.9 127.959 213.849 L 117.962 214.178 C 118.194 213.165 118.462 212.143 118.731 211.093 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#d0ccc8",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path145",
    strokeLinejoin: "round",
    d: "M 136.928 204.55 L 129.69 210.235 C 127.728 209.943 125.895 209.715 124.192 209.551 C 122.359 209.314 120.832 209.286 119.231 209.186 C 121.461 200.415 124.331 192.923 127.959 186.315 C 131.458 179.717 139.289 167.953 140.659 169.797 C 141.955 171.695 140.427 180.703 135.929 197.322 C 134.124 196.637 132.43 197.322 130.458 199.037 C 128.496 200.707 124.831 206.43 124.46 207.808 C 123.96 209.085 126.626 208.1 127.959 207.114 C 129.329 206.001 130.727 202.743 132.43 201.794 C 133.957 200.872 135.623 200.771 137.428 201.629 C 137.262 202.578 137.095 203.564 136.928 204.55 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path147",
    strokeLinejoin: "round",
    d: "M 253.15 215.392 C 252.724 214.707 255.02 214.242 258.389 214.014 C 261.721 213.722 267.645 214.077 273.116 213.329 C 278.475 212.307 285.38 209.578 290.573 208.693 C 295.71 207.771 300.708 207.342 303.772 208.164 C 306.706 208.985 308.502 211.778 308.271 213.493 C 307.873 214.999 306.734 217.235 302.041 217.792 C 297.136 218.285 287.074 216.907 280.076 216.943 C 273.079 216.97 265.146 218.385 260.647 218.157 C 256.019 217.764 253.52 216.085 253.15 215.392 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path149",
    strokeLinejoin: "round",
    d: "M 93.473 208.985 C 86.242 208.857 79.211 208.693 72.014 208.629 C 64.716 208.465 57.318 208.2 50.587 208.465 C 43.856 208.729 37.825 209.25 32.127 210.171 L 32.626 217.6 C 34.126 218.157 35.992 219.143 38.358 220.685 C 40.724 222.063 44.622 223.085 46.588 226.535 C 48.421 230.012 49.288 234.776 49.321 241.319 C 50.554 238.919 53.253 236.72 57.552 234.447 C 61.917 232.147 68.681 228.835 75.013 227.913 C 81.244 226.991 89.708 227.52 94.473 228.606 C 99.07 229.619 103.402 233.37 102.44 233.763 C 101.301 234.027 93.44 230.505 87.975 230.313 C 82.377 229.985 75.879 229.848 69.781 232.22 C 63.616 234.484 56.985 239.02 51.82 244.441 C 46.655 249.889 41.723 259.225 39.091 264.582 C 36.392 269.802 35.359 273.48 35.859 275.753 C 39.091 275.515 41.79 275.844 44.089 276.866 C 46.355 277.852 48.188 279.166 49.588 281.694 C 50.92 284.158 51.953 287.088 52.32 291.486 C 52.553 295.821 52.52 303.542 51.587 307.686 C 50.687 311.728 49.054 314.32 46.822 315.598 C 47.988 316.748 49.488 317.149 51.32 316.784 C 53.12 316.356 56.052 316.52 57.552 313.371 C 58.884 310.049 59.251 303.606 59.818 297.857 C 60.317 292.043 59.318 284.751 61.05 279.266 C 62.75 273.708 65.649 268.452 70.281 265.002 C 74.979 261.425 83.277 258.34 88.741 258.267 C 94.073 258.303 99.2 260.731 102.199 264.81 C 105.031 268.78 104.772 274.338 106.438 281.858 C 108.068 289.251 110.835 302.858 112.168 309.228 C 113.334 315.507 112.631 316.328 113.936 319.805 C 115.269 323.255 116.102 327.298 119.897 329.798 C 123.599 332.098 125.497 333.212 136.123 334.426 C 146.759 335.676 169.011 336.725 183.247 337.191 C 197.372 337.419 210.969 336.953 220.429 336.333 C 229.732 335.74 233.962 335.676 238.895 333.741 C 243.727 331.605 246.485 328.776 249.355 324.113 C 252.058 319.349 253.483 312.513 255.584 305.879 C 257.621 299.043 259.657 290.437 262.082 284.359 C 264.489 278.308 265.979 273.353 270.052 270.231 C 274.05 267.11 281.807 264.318 286.278 265.759 C 290.712 267.174 294.544 273.544 296.738 278.673 C 298.811 283.665 298.57 289.579 299.237 295.529 C 299.903 301.343 300.144 308.671 300.977 313.435 C 301.838 318.062 302.069 321.22 304.235 323.419 C 306.373 325.391 312.232 326.212 313.204 326.02 C 313.936 325.692 310.307 324.277 308.965 322.406 C 307.503 320.627 305.707 319.285 305.235 315.178 C 304.772 310.907 304.235 301.836 306.475 297.108 C 308.641 292.344 314.935 288.794 318.434 286.586 C 321.831 284.286 324.969 284.879 326.931 283.3 C 328.829 281.657 329.097 281.429 329.662 276.766 C 330.134 271.938 329.829 262.182 329.93 255.082 C 329.995 247.89 330.301 239.868 329.93 234.447 C 329.468 228.999 330.264 225.613 326.931 222.921 C 323.368 220.156 317.638 218.65 309.206 218.248 C 307.706 219.663 305.17 220.32 301.477 220.484 C 297.672 220.548 292.674 218.942 287.009 218.942 C 281.28 218.841 274.282 220.621 267.821 220.32 C 261.323 219.991 254.927 218.914 248.355 217.071 C 221.503 216.779 197.946 216.642 176.517 216.542 C 155.024 216.414 135.929 216.414 120.897 216.542 C 105.809 216.514 97.71 216.779 87.244 216.97 C 76.747 217.171 66.117 217.564 58.82 218.02 C 51.555 218.422 45.491 219.827 43.825 219.736 C 41.992 219.571 42.158 218.221 48.323 217.336 C 54.521 216.35 69.916 215.136 80.513 214.57 C 91.043 213.986 100.977 213.986 110.937 214.214 C 105.133 212.471 99.302 210.728 93.473 208.985 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(85, 255, 125)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path151",
    strokeLinejoin: "round",
    d: "M 36.092 261.196 C 35.592 263.624 34.926 265.988 34.359 268.424 C 33.726 270.752 33.06 273.152 32.36 275.488 L 28.628 275.324 C 28.894 273.873 29.061 272.166 28.861 270.323 C 28.728 268.424 28.228 266.252 27.628 263.952 C 28.194 265.002 29.194 265.203 30.627 264.81 C 32.093 264.281 33.793 263.168 36.092 261.196 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path153",
    strokeLinejoin: "round",
    d: "M 21.13 274.794 L 25.895 274.959 C 26.195 272.595 26.362 270.167 26.395 267.932 C 26.362 265.659 26.195 263.332 25.895 261.196 C 25.195 261.388 24.362 261.16 23.396 260.503 C 22.43 259.745 21.297 258.696 20.13 257.09 C 19.431 259.189 19.231 261.625 19.397 264.646 C 19.564 267.566 20.097 270.952 21.13 274.794 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path155",
    strokeLinejoin: "round",
    d: "M 33.859 260.704 C 37.292 258.367 39.991 255.383 42.09 251.732 C 44.223 247.991 46.055 242.862 46.322 238.654 C 46.355 234.42 44.989 229.291 42.856 226.434 C 40.724 223.414 37.691 221.671 33.626 220.95 C 35.126 226.635 35.992 231.956 36.358 237.276 C 36.692 242.57 35.925 248.383 35.592 252.426 C 35.159 256.296 34.626 259.061 33.859 260.704 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(238, 147, 117)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path157",
    strokeLinejoin: "round",
    d: "M 24.896 219.042 C 24.762 220.913 26.528 224.792 27.128 230.048 C 27.628 235.269 27.828 245.061 28.128 250.026 C 28.361 254.917 28.394 256.989 28.628 259.161 C 28.728 261.26 28.594 262.474 29.128 262.41 C 29.727 262.182 30.894 262.474 31.86 258.103 C 32.66 253.539 34.059 241.913 34.126 235.898 C 34.026 229.82 33.226 225.348 32.127 222.492 C 30.994 219.535 29.061 219.471 27.861 218.878 C 26.595 218.184 24.962 217.235 24.896 219.042 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path159",
    strokeLinejoin: "round",
    d: "M 23.129 220.749 C 21.863 220.648 20.097 226.663 19.131 231.426 C 18.131 236.163 16.565 243.884 17.398 248.648 C 18.231 253.275 22.363 258.139 23.896 259.161 C 25.295 260.147 25.495 258.568 25.895 254.16 C 26.162 249.496 26.328 237.568 25.895 231.956 C 25.362 226.27 24.229 220.886 23.129 220.749 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(220, 245, 26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path161",
    strokeLinejoin: "round",
    d: "M 23.396 210.436 L 23.629 216.97 C 24.229 216.642 25.195 216.35 26.395 216.45 C 27.561 216.45 29.094 216.678 30.86 217.135 C 31.393 214.077 31.06 212.106 29.861 210.956 C 28.528 209.879 26.495 209.615 23.396 210.436 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path163",
    strokeLinejoin: "round",
    d: "M 23.629 204.75 C 23.096 205.508 22.93 206.192 23.129 206.822 C 23.296 207.379 24.262 208.072 24.629 208.364 C 24.862 208.593 24.862 208.593 24.629 208.364 L 28.128 208.364 L 27.628 205.28 C 26.295 205.115 24.962 204.951 23.629 204.75 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path165",
    strokeLinejoin: "round",
    d: "M 24.396 202.88 C 25.762 203.308 29.161 203.308 30.36 202.88 C 31.527 202.387 32.293 200.872 31.36 200.114 C 30.294 199.266 25.662 197.979 24.129 198.052 C 22.53 198.052 21.83 199.43 21.897 200.279 C 21.897 201.073 22.896 202.35 24.396 202.88 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path167",
    strokeLinejoin: "round",
    d: "M 22.03 213.028 L 19.964 211.586 C 18.764 212.106 17.898 212.699 17.498 213.229 C 16.998 213.722 16.931 214.278 17.298 214.771 L 21.463 214.771 C 21.63 214.214 21.83 213.621 22.03 213.028 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path169",
    strokeLinejoin: "round",
    d: "M 14.199 224.299 C 14.232 224.691 14.232 225.12 14.199 225.713 C 14.166 226.206 14.099 226.863 13.999 227.548 C 16.232 227.52 17.731 227.32 18.631 226.964 C 19.397 226.498 19.931 225.485 19.197 225.056 C 18.364 224.527 16.832 224.399 14.199 224.299 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path171",
    strokeLinejoin: "round",
    d: "M 13.932 228.835 C 13.832 229.09 13.766 229.656 13.733 230.149 C 13.666 230.733 13.633 231.262 13.633 232.084 L 16.665 232.348 C 17.331 231.627 17.731 230.934 17.865 230.404 C 17.898 229.784 17.698 229.327 17.131 228.899 C 16.065 228.899 14.999 228.862 13.932 228.835 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path173",
    strokeLinejoin: "round",
    d: "M 13.666 234.849 C 13.666 235.141 13.499 235.57 13.533 236.127 C 13.466 236.647 13.433 237.304 13.433 238.098 L 15.932 238.326 C 16.498 237.605 16.832 236.911 16.931 236.391 C 16.965 235.761 16.798 235.269 16.298 234.913 C 15.432 234.913 14.566 234.876 13.666 234.849 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path175",
    strokeLinejoin: "round",
    d: "M 13.366 239.777 C 13.266 240.033 13.266 240.598 13.233 241.091 C 13.199 241.675 13.133 242.205 13.166 243.026 L 15.365 243.291 C 15.898 242.57 16.198 241.876 16.265 241.347 C 16.265 240.726 16.165 240.27 15.699 239.841 C 14.932 239.841 14.166 239.804 13.366 239.777 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path177",
    strokeLinejoin: "round",
    d: "M 14.766 220.648 C 14.799 221.05 14.799 221.47 14.766 222.063 C 14.732 222.556 14.666 223.213 14.566 223.906 C 16.798 223.87 18.298 223.678 19.197 223.313 C 19.964 222.857 20.497 221.835 19.764 221.406 C 18.931 220.886 17.398 220.749 14.766 220.648 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path179",
    strokeLinejoin: "round",
    d: "M 15.699 216.085 C 15.732 216.45 15.732 216.97 15.699 217.527 C 15.665 218.057 15.565 218.613 15.532 219.334 C 17.798 219.307 19.164 219.106 20.13 218.75 C 20.897 218.285 21.43 217.235 20.697 216.87 C 19.864 216.377 18.331 216.122 15.699 216.085 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path181",
    strokeLinejoin: "round",
    d: "M 12.833 244.276 C 12.766 244.568 12.666 244.997 12.666 245.554 C 12.633 246.083 12.566 246.74 12.6 247.525 L 15.065 247.79 C 15.632 246.996 15.965 246.339 16.065 245.819 C 16.098 245.189 15.898 244.696 15.465 244.34 C 14.599 244.34 13.733 244.304 12.833 244.276 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path183",
    strokeLinejoin: "round",
    d: "M 12.866 248.876 C 12.8 249.141 12.7 249.697 12.7 250.19 C 12.633 250.774 12.6 251.303 12.6 252.125 L 15.599 252.39 C 16.332 251.669 16.698 250.975 16.832 250.446 C 16.898 249.825 16.598 249.369 16.065 248.94 C 14.999 248.94 13.932 248.903 12.866 248.876 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path185",
    strokeLinejoin: "round",
    d: "M 12.833 253.576 C 12.7 253.831 12.666 254.397 12.6 254.89 C 12.533 255.474 12.5 256.004 12.5 256.825 L 15.965 257.09 C 16.832 256.369 17.265 255.675 17.398 255.146 C 17.498 254.525 17.165 254.069 16.532 253.64 C 15.299 253.64 14.066 253.603 12.833 253.576 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path187",
    strokeLinejoin: "round",
    d: "M 12.933 259.024 C 12.8 259.289 12.766 259.846 12.7 260.338 C 12.633 260.932 12.6 261.461 12.6 262.273 L 16.065 262.538 C 16.931 261.817 17.365 261.123 17.498 260.603 C 17.598 259.973 17.265 259.517 16.632 259.088 C 15.399 259.088 14.166 259.061 12.933 259.024 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path189",
    strokeLinejoin: "round",
    d: "M 12.733 263.989 C 12.6 264.254 12.566 264.81 12.5 265.303 C 12.433 265.887 12.4 266.417 12.4 267.238 L 15.865 267.503 C 16.732 266.782 17.165 266.088 17.298 265.568 C 17.398 264.938 17.065 264.482 16.432 264.053 C 15.199 264.053 13.966 264.016 12.733 263.989 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path191",
    strokeLinejoin: "round",
    d: "M 13.399 268.981 C 13.266 269.31 13.233 269.702 13.166 270.295 C 13.099 270.825 13.066 271.482 13.066 272.267 L 16.532 272.495 C 17.398 271.774 17.831 271.08 17.964 270.56 C 18.064 269.93 17.731 269.437 17.098 269.081 C 15.865 269.045 14.632 269.018 13.399 268.981 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path193",
    strokeLinejoin: "round",
    d: "M 16.532 277.03 C 12.4 277.395 12.066 278.408 10.534 280.845 C 8.867 283.145 6.468 286.23 7.068 291.486 C 7.668 296.743 9.134 308.014 14.032 312.477 C 18.798 316.821 30.227 318.391 35.725 317.834 C 41.09 317.241 44.323 314.193 46.455 309.064 C 48.521 303.743 50.054 291.851 48.221 286.686 C 46.189 281.502 40.324 279.823 34.992 278.244 C 29.627 276.601 20.564 276.538 16.532 277.03 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(24, 254, 139)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path195",
    strokeLinejoin: "round",
    d: "M 317.296 290.501 C 314.833 292.016 312.797 293.75 311.335 296.871 C 309.798 300.065 308.502 305.121 308.604 309.264 C 308.567 313.234 308.835 318.226 311.834 320.955 C 314.898 323.62 321.461 325.391 326.533 325.263 C 331.43 325.025 337.03 324.304 341.029 319.933 C 344.926 315.306 349.119 303.707 349.757 298.587 C 350.155 293.522 348.323 291.258 344.259 289.479 C 340.057 287.571 330.097 287.179 325.534 287.407 C 320.97 287.644 319.637 288.758 317.296 290.501 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      paintOrder: "fill",
      fill: "rgb(24, 254, 139)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path197",
    strokeLinejoin: "round",
    d: "M 308.104 327.855 C 316.268 328.247 323.368 328.384 329.532 328.384 C 335.623 328.32 340.658 328.019 344.759 327.49 C 343.491 330.784 342.991 333.44 343.259 335.612 C 343.491 337.711 344.49 339.253 346.258 340.239 C 340.788 338.368 334.929 336.826 328.292 335.612 C 321.6 334.362 314.5 333.44 306.605 332.847 C 307.105 331.204 307.604 329.534 308.104 327.855 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(229, 247, 200)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path199",
    strokeLinejoin: "round",
    d: "M 366.187 317.177 C 362.753 317.049 360.217 317.442 358.449 318.719 C 356.588 319.906 355.255 322.735 355.718 324.405 C 356.218 326.02 358.088 327.298 361.448 328.384 C 356.616 334.033 355.117 337.939 356.949 340.239 C 358.754 342.511 363.78 343.032 372.185 341.946 C 377.443 346.052 381.349 347.44 383.876 346.454 C 386.412 345.368 387.375 341.754 387.143 335.612 C 391.475 333.969 394.345 331.934 396.103 329.233 C 397.806 326.477 398.436 321.056 397.371 319.577 C 396.177 318.062 393.475 318.299 389.143 320.271 C 391.679 317.67 393.039 315.105 393.604 312.714 C 393.974 310.25 393.345 306.663 392.105 305.65 C 390.874 304.592 389.013 304.92 386.375 306.499 C 384.514 305.185 382.478 304.793 380.645 305.322 C 378.776 305.842 376.748 307.092 374.916 309.429 C 371.352 307.686 368.483 307.056 366.187 307.549 C 363.78 308.041 361.217 310.478 361.189 312.185 C 361.189 313.828 362.855 315.406 366.187 317.177 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path201",
    strokeLinejoin: "round",
    d: "M 370.686 318.883 C 366.28 318.135 363.086 318.199 360.948 319.084 C 358.717 320.033 357.283 322.333 357.949 324.076 C 358.653 325.655 361.022 327.097 365.187 328.548 C 360.189 333.604 358.486 337.054 359.948 339.025 C 361.42 340.996 366.15 341.225 374.147 340.075 C 378.544 343.597 381.71 344.674 383.644 343.689 C 385.542 342.603 386.208 339.317 385.644 333.705 C 389.309 332.162 391.845 330.483 393.382 328.548 C 394.807 326.513 395.946 323.291 394.613 322.169 C 393.178 321.019 390.142 320.955 385.144 321.84 C 387.078 320.499 388.448 318.756 389.374 316.492 C 390.179 314.22 390.975 309.456 390.374 308.407 C 389.744 307.257 388.208 307.713 385.644 309.785 C 384.875 308.114 383.913 307.521 382.376 307.877 C 380.849 308.306 378.979 309.52 376.647 312.021 C 372.518 309.556 369.482 308.571 367.418 308.571 C 365.28 308.671 363.855 310.478 364.419 312.349 C 364.984 314.056 366.983 316.191 370.686 318.883 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(167, 160, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path203",
    strokeLinejoin: "round",
    d: "M 54.419 318.82 C 53.886 320.106 54.319 322.899 55.852 327.334 C 57.218 331.733 58.984 339.746 63.35 345.039 C 67.782 350.196 75.146 356.575 82.21 358.218 C 89.275 359.66 98.136 358.145 104.939 354.202 C 111.465 350.196 117.028 343.625 121.628 334.362 C 116.63 331.605 113.131 328.019 111.002 323.483 C 108.901 318.82 109.798 314.22 108.799 307.156 C 107.568 300.093 106.003 288.393 104.235 281.466 C 102.44 274.439 101.736 268.753 98.404 265.431 C 94.906 262.145 88.908 260.932 84.409 261.425 C 79.911 261.753 75.446 264.281 72.047 267.603 C 68.581 270.852 65.416 274.931 63.85 280.973 C 62.217 286.987 62.55 297.993 62.15 303.478 C 61.584 308.772 61.95 310.606 60.684 313.17 C 59.318 315.735 57.352 317.569 54.419 318.82 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(42, 94, 120)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path205",
    strokeLinejoin: "round",
    d: "M 79.544 304.135 C 79.011 307.457 79.145 307.521 79.811 310.15 C 80.411 312.714 80.677 317.606 83.443 319.513 C 86.176 321.384 92.407 322.698 96.239 321.156 C 100.005 319.477 104.772 314.713 105.902 309.657 C 106.864 304.5 105.235 295 102.532 290.793 C 99.774 286.494 93.307 284.587 89.941 284.459 C 86.475 284.359 84.243 286.759 82.477 290.136 C 80.644 293.394 80.011 300.722 79.544 304.135 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path207",
    strokeLinejoin: "round",
    d: "M 81.71 304.099 C 81.244 307.129 81.311 307.129 81.91 309.556 C 82.443 311.856 82.777 316.492 85.209 317.998 C 87.608 319.413 93.04 319.778 96.239 318.327 C 99.367 316.721 102.903 313.535 103.736 309.164 C 104.337 304.692 102.44 296.123 100.339 292.308 C 98.136 288.402 93.773 286.394 91.107 286.294 C 88.275 286.166 85.976 288.301 84.343 291.423 C 82.743 294.316 82.077 301.078 81.71 304.099 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path209",
    strokeLinejoin: "round",
    d: "M 239.321 337.026 C 238.46 337.446 238.321 338.897 239.062 341.361 C 239.589 343.762 240.959 348.589 243.422 351.546 C 245.986 354.403 250.086 357.068 254.288 359.039 C 258.352 361.001 262.619 363.045 267.849 363.374 C 273.079 363.602 279.91 363.438 285.241 360.709 C 290.471 357.789 295.803 352.432 299.042 346.682 C 302.134 340.933 303.707 334.298 303.874 326.513 C 301.504 325.819 299.94 323.748 298.774 320.17 C 297.608 316.456 297.441 310.214 297.108 304.993 C 296.738 299.737 297.006 294.151 296.377 289.123 C 295.636 284.03 294.636 278.281 292.739 274.794 C 290.638 271.18 287.639 268.78 284.51 267.959 C 281.381 267.174 277.281 268.123 274.384 269.93 C 271.449 271.609 269.58 272.887 267.118 277.952 C 264.554 282.88 261.582 292.764 259.62 299.636 C 257.648 306.435 257.482 313.07 255.251 318.655 C 252.854 324.076 248.253 329.005 245.588 332.162 C 242.922 335.247 240.793 336.826 239.321 337.026 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(42, 94, 120)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path211",
    strokeLinejoin: "round",
    d: "M 262.119 305.979 C 261.619 309.292 261.647 309.356 262.351 311.984 C 262.952 314.585 263.221 319.376 265.979 321.32 C 268.719 323.127 274.948 324.569 278.78 322.99 C 282.548 321.32 287.315 316.556 288.444 311.491 C 289.444 306.335 287.676 296.844 285.075 292.636 C 282.279 288.329 275.948 286.43 272.514 286.294 C 269.08 286.193 266.747 288.593 265.016 291.979 C 263.221 295.228 262.554 302.557 262.119 305.979 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path213",
    strokeLinejoin: "round",
    d: "M 264.248 305.942 C 263.785 308.963 263.85 309 264.452 311.363 C 264.979 313.663 265.313 318.263 267.747 319.842 C 270.144 321.256 275.578 321.612 278.78 320.17 C 281.909 318.555 285.445 315.37 286.278 310.998 C 286.972 306.536 284.908 297.957 282.909 294.142 C 280.715 290.236 276.383 288.237 273.643 288.137 C 270.885 288 268.413 290.136 266.886 293.257 C 265.285 296.15 264.618 302.922 264.248 305.942 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path215",
    strokeLinejoin: "round",
    d: "M 137.891 186.717 C 136.262 186.188 134.929 186.151 133.522 186.251 C 132.023 186.315 130.662 186.288 129.792 187.566 C 128.959 188.852 128.598 190.888 128.69 193.808 C 127.83 193.644 127.265 193.945 126.728 194.693 C 126.099 195.387 125.562 196.829 125.627 198.143 C 125.728 199.457 126.191 200.707 127.163 202.25 C 125.266 202.286 124.359 202.98 124.099 204.194 C 123.831 205.344 123.692 208.656 125.858 209.578 C 127.996 210.5 131.597 210.564 136.79 209.779 C 136.891 206.749 137.095 203.929 137.262 201.164 C 137.456 198.28 137.623 195.323 137.891 193.187 C 138.021 191.052 138.261 189.5 138.326 188.424 C 138.354 187.301 138.123 186.781 137.891 186.717 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path217",
    strokeLinejoin: "round",
    d: "M 127.126 204.358 C 127.959 204.714 129.163 206.557 130.597 206.95 C 131.93 207.251 134.161 206.101 134.994 206.43 C 135.725 206.658 136.021 208.2 134.994 208.656 C 133.855 209.022 130.06 209.149 128.459 208.921 C 126.663 208.593 125.562 207.507 125.025 206.822 C 124.525 206.065 125.127 204.814 125.562 204.486 C 125.765 204.029 126.33 203.893 127.126 204.358 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path219",
    strokeLinejoin: "round",
    d: "M 139.89 189.674 C 140.955 189.601 141.89 189.993 142.825 190.851 C 143.686 191.609 144.787 192.795 145.352 194.666 C 145.852 196.537 145.99 198.937 145.889 201.994 L 150.785 205.143 C 151.516 202.743 152.322 200.251 153.321 197.258 C 154.219 194.2 155.422 190.167 156.654 187.438 C 157.848 184.609 159.347 181.752 160.884 180.767 C 162.346 179.781 163.947 180.046 165.678 181.551 C 171.112 178.403 175.777 174.816 180.044 170.938 C 184.311 166.995 187.773 162.76 190.939 158.097 L 192.938 156.518 C 192.707 155.898 193.243 152.576 194.669 146.434 C 196.076 140.219 198.242 131.348 201.306 119.557 C 198.871 118.507 197.242 117.029 196.141 114.994 C 195.039 112.822 194.169 108.587 194.808 107.236 C 195.372 105.858 198.205 106.123 199.704 107.008 C 201.074 107.893 202.268 109.472 203.305 112.228 C 202.935 108.286 203.074 104.279 203.573 100.205 C 204.138 96.033 204.906 90.316 206.369 87.622 C 207.665 84.764 210.497 81.938 211.404 83.844 C 212.2 85.848 212.2 90.908 211.265 99.417 C 213.302 94.456 215.162 91.138 216.865 89.462 C 218.494 87.786 220.762 88.082 221.234 89.331 C 221.531 90.448 220.568 92.813 219.494 96.296 C 218.467 99.68 217.097 104.079 215.264 109.637 C 217.763 105.201 220.068 102.272 221.901 100.863 C 223.734 99.351 225.659 100.107 226.427 100.994 C 227.066 101.815 227.232 103.951 226.298 105.986 C 225.298 107.93 223.595 110.193 220.827 112.785 C 223.632 111.507 225.798 111.115 227.464 111.343 C 229.195 111.608 230.426 113.086 230.657 114.364 C 230.657 115.55 229.426 117.029 227.732 118.407 C 225.825 119.621 222.364 119.758 220.031 121.957 C 217.698 124.193 216.264 126.192 213.663 131.512 C 210.932 136.742 205.739 147.447 203.833 153.005 C 201.833 158.426 201.167 162.14 201.833 164.139 C 203.472 164.038 204.268 164.567 204.369 165.845 C 204.434 167.068 203.166 168.775 202.37 171.595 C 201.472 174.323 200.704 177.317 199.306 182.473 C 199.306 182.473 195.308 196.829 193.836 202.478 C 192.41 208.1 191.411 212.471 190.837 215.948 L 150.387 215.948 C 148.49 216.213 146.62 215.72 145.157 214.47 C 143.686 213.156 142.26 210.199 141.122 208.392 C 139.853 206.521 138.521 204.778 137.391 203.299 C 138.224 198.773 139.057 194.237 139.89 189.674 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path221",
    strokeLinejoin: "round",
    d: "M 131.662 188.095 C 130.792 188.36 130.69 189.701 130.597 191.116 C 130.357 192.53 129.764 195.022 130.597 196.336 C 131.328 197.459 134.161 199.457 135.124 198.307 C 135.929 196.993 136.493 190.988 135.929 189.272 C 135.225 187.538 132.56 187.73 131.662 188.095 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path223",
    strokeLinejoin: "round",
    d: "M 128.857 196.208 C 129.598 196.701 130.097 198.344 131.125 199.366 C 132.124 200.251 134.226 200.744 134.596 201.593 C 134.855 202.414 133.726 204.358 132.726 204.221 C 131.495 203.966 128.996 201.465 127.931 200.279 C 126.793 198.937 126.358 197.459 126.497 196.728 C 126.626 196.007 128.061 195.715 128.857 196.208 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path225",
    strokeLinejoin: "round",
    d: "M 141.927 192.165 C 142.186 191.672 143.019 192.923 143.519 194.009 C 143.889 194.994 144.759 196.902 144.722 198.307 C 144.556 199.722 143.723 201.337 143.121 201.994 C 142.39 202.487 141.288 202.35 140.992 201.465 C 140.659 200.443 141.223 198.28 141.39 196.738 C 141.455 195.058 141.594 192.695 141.927 192.165 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path227",
    strokeLinejoin: "round",
    d: "M 145.518 204.093 C 146.851 204.623 147.823 205.179 148.554 205.773 C 149.221 206.265 149.619 206.95 149.758 207.479 C 149.489 210.135 149.221 212.106 148.823 213.128 C 148.388 214.114 147.953 214.406 147.388 213.749 C 146.786 214.242 146.259 214.077 145.657 213.256 C 145.055 212.343 144.389 210.929 143.787 208.656 C 144.019 208.136 144.287 207.607 144.593 206.822 C 144.889 206.001 145.157 205.179 145.518 204.093 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path229",
    strokeLinejoin: "round",
    d: "M 150.591 213.913 C 150.683 211.915 151.257 209.122 152.285 205.28 C 153.182 201.428 155.256 194.894 156.552 191.116 C 157.885 187.274 158.949 184.052 160.115 182.61 C 161.115 181.095 162.05 181.98 163.05 182.081 C 163.947 182.117 165.049 182.373 165.984 182.866 C 166.15 183.066 167.78 182.181 170.88 179.717 C 173.944 177.189 181.044 171.695 184.441 168.446 C 187.838 165.325 189.837 162.633 190.939 160.725 C 191.411 161.939 192.605 163.153 194.539 164.011 C 196.474 164.732 201.306 164.96 202.37 166.11 C 203.24 167.296 201.074 168.875 200.241 171.467 C 199.436 173.995 199.103 174.196 197.437 181.296 C 195.641 188.387 193.003 198.937 189.541 213.557 C 182.58 213.722 176.008 213.886 169.483 213.913 C 162.948 213.95 156.654 213.95 150.591 213.913 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(196, 236, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path231",
    strokeLinejoin: "round",
    d: "M 195.474 191.38 C 194.002 192.33 192.771 192.466 192.142 191.773 C 191.476 191.015 191.04 189.573 191.207 187.173 C 188.912 186.553 187.977 185.594 188.273 184.317 C 188.504 182.939 190.106 181.36 192.938 179.325 C 191.309 177.317 190.772 175.574 191.078 174.232 C 191.411 172.653 193.475 171.011 194.937 171.075 C 196.372 171.239 197.872 172.553 199.575 175.145 C 198.205 180.538 196.835 185.959 195.474 191.38 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path233",
    strokeLinejoin: "round",
    d: "M 195.872 189.145 C 194.706 190.231 193.91 190.751 193.336 190.723 C 192.67 190.586 192.244 189.637 192.41 188.752 C 192.503 187.794 193.169 186.717 194.271 185.366 C 192.142 185.795 190.939 185.658 190.67 185.102 C 190.374 184.381 191.503 182.309 192.41 181.688 C 193.169 181.132 194.243 180.995 195.474 181.551 C 193.577 178.832 192.642 176.824 192.54 175.546 C 192.475 174.159 193.873 173.21 194.937 173.575 C 195.872 173.803 196.974 175.017 198.242 177.089 C 197.474 181.095 196.668 185.102 195.872 189.145 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(14, 184, 235)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path235",
    strokeLinejoin: "round",
    d: "M 159.218 158.161 C 158.921 162.925 159.051 167.424 159.754 171.668 C 160.384 175.838 160.421 180.402 163.087 183.331 C 165.678 186.251 171.51 189.902 175.314 188.944 C 179.007 187.766 182.839 182.017 185.274 176.888 C 187.643 171.604 188.245 162.268 189.245 158.298 C 190.004 154.383 189.671 155.432 190.439 153.725 C 191.244 151.891 193.04 149.756 193.771 147.949 C 194.41 146.041 194.539 144.006 194.04 142.856 C 193.373 141.67 191.411 141.177 190.439 141.013 C 189.504 140.784 188.837 141.049 188.439 141.67 L 188.578 139.826 C 190.078 138.549 191.411 137.764 192.707 137.07 C 193.938 136.413 195.002 135.984 196.039 135.92 L 190.17 135.391 C 190.874 134.542 191.809 133.748 192.975 133.027 C 194.077 132.306 195.409 131.649 196.974 131.056 C 195.835 130.435 194.641 130.043 193.503 129.879 C 192.244 129.614 191.17 129.614 189.911 129.742 C 192.272 129.185 194.002 128.656 195.243 128.427 C 196.437 128.135 197.14 127.999 197.205 128.035 C 195.409 127.542 193.771 127.278 192.17 127.25 C 190.541 127.113 188.773 127.414 187.643 127.506 C 186.44 127.542 185.607 127.542 185.144 127.506 C 185.774 126.922 186.875 126.356 188.578 126.1 C 190.272 125.799 192.41 125.534 195.243 125.571 L 190.439 124.649 L 194.974 123.207 L 188.976 121.236 C 188.375 120.415 187.144 119.758 185.413 119.392 C 183.645 118.964 181.247 118.836 178.341 118.872 C 177.711 117.485 176.342 117.093 174.25 117.421 C 172.01 117.786 167.983 119.128 165.614 120.971 C 163.318 122.678 161.448 125.407 160.282 127.643 C 158.949 129.778 157.848 131.877 158.014 133.949 C 158.116 135.884 159.051 137.764 160.948 139.571 C 158.986 139.927 157.653 140.885 157.089 142.062 C 156.45 143.249 156.755 145.448 157.218 146.89 C 157.616 148.277 158.283 149.327 159.347 150.175 C 159.319 152.84 159.282 155.505 159.218 158.161 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path237",
    strokeLinejoin: "round",
    d: "M 161.217 151.754 C 160.948 153.826 160.819 155.432 160.948 156.719 C 160.948 157.869 160.921 158.526 161.754 159.083 C 162.448 159.575 163.651 160.269 165.752 160.004 C 167.817 159.639 171.251 159.019 174.25 157.239 C 177.249 155.341 181.71 149.591 183.274 149.263 C 184.607 148.998 183.58 151.398 183.006 155.304 C 182.414 159.146 181.21 167.853 179.942 171.932 C 178.646 175.802 177.008 178.668 175.175 178.859 C 173.176 178.96 170.482 175.775 168.511 172.982 C 166.511 170.125 164.882 166.539 163.485 162.103 L 160.421 162.103 C 160.615 167.068 161.152 171.175 162.152 174.561 C 163.114 177.846 164.447 180.374 166.15 182.145 C 167.678 183.888 169.418 184.937 171.982 185.038 C 174.611 184.937 179.211 184.016 181.414 182.145 C 183.478 180.21 183.173 177.874 184.478 173.767 C 185.774 169.532 187.44 160.853 188.708 157.111 C 189.837 153.297 190.605 153.068 191.374 151.234 C 192.105 149.327 192.642 147.155 192.836 145.877 C 192.873 144.426 192.438 143.513 191.911 143.249 C 191.374 142.947 190.578 143.349 189.643 144.298 L 187.505 141.405 L 181.812 141.277 C 181.942 142.92 181.544 144.234 180.748 145.22 C 179.914 146.142 178.211 146.826 176.915 147.155 C 175.481 147.483 173.842 147.647 172.648 147.027 C 171.417 146.269 170.482 144.919 169.714 142.856 L 167.715 142.856 C 167.983 144.462 167.817 145.813 167.215 147.027 C 166.613 148.177 165.549 149.098 164.151 149.783 C 163.679 150.933 163.679 151.727 164.151 152.284 C 164.549 152.74 165.512 153.297 166.919 152.941 C 168.178 152.576 171.112 150.175 172.111 150.175 C 173.111 150.084 173.546 151.298 172.778 152.411 C 171.75 153.497 168.548 155.861 166.919 156.491 C 165.317 156.947 164.216 156.126 163.485 155.304 C 162.652 154.383 162.42 153.068 162.42 151.234 C 162.013 151.398 161.615 151.563 161.217 151.754 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path239",
    strokeLinejoin: "round",
    d: "M 165.882 162.496 C 165.984 164.303 166.678 166.146 167.844 168.382 C 169.048 170.582 171.38 174.853 173.046 175.473 C 174.546 175.902 175.749 175.054 177.147 171.531 C 178.508 167.917 179.84 162.332 181.275 154.383 C 177.508 157.604 174.416 159.74 171.843 161.182 C 169.279 162.532 167.252 162.925 165.882 162.496 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path241",
    strokeLinejoin: "round",
    d: "M 162.948 138.512 C 163.846 138.256 164.484 138.384 165.216 138.649 C 165.845 138.914 166.419 139.434 166.919 140.228 L 169.446 140.228 C 169.279 138.713 169.677 137.663 170.649 136.942 C 171.547 136.185 173.444 135.92 175.046 135.792 C 176.508 135.528 178.609 135.363 179.674 135.792 C 180.673 136.212 181.21 136.869 181.275 138.12 L 185.144 137.992 C 184.08 136.942 183.543 136.285 183.543 135.655 C 183.506 134.998 184.978 135.035 184.876 134.478 C 184.607 133.748 182.747 132.963 182.478 132.105 C 182.173 131.22 183.506 129.842 183.145 129.477 C 182.58 129.121 180.609 129.714 179.674 129.614 C 178.646 129.349 178.582 128.099 177.545 128.035 C 176.416 127.871 174.148 129.021 173.444 128.957 C 172.75 128.756 173.778 127.341 173.315 127.25 C 172.547 127.086 171.343 127.807 169.844 128.035 C 168.381 128.163 166.012 127.707 164.947 128.163 C 163.947 128.592 164.151 129.806 163.485 130.536 C 162.55 131.056 160.282 130.563 160.152 131.85 C 160.115 133.228 160.884 135.327 162.948 138.512 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path243",
    strokeLinejoin: "round",
    d: "M 161.087 135.135 C 162.115 134.807 163.179 134.506 164.281 134.606 C 165.419 134.606 167.419 134.871 167.585 135.263 C 167.585 135.628 165.715 136.313 164.679 136.705 C 163.549 136.97 162.346 137.134 161.087 137.07 L 161.087 135.135 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path245",
    strokeLinejoin: "round",
    d: "M 172.111 133.027 C 172.509 132.534 175.509 132.27 177.008 132.242 C 178.341 132.206 181.044 132.47 180.609 132.899 C 180.081 133.255 175.777 134.378 174.379 134.478 C 172.917 134.478 171.649 133.356 172.111 133.027 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path247",
    strokeLinejoin: "round",
    d: "M 160.819 129.614 C 161.18 129.714 161.754 129.714 162.152 129.349 C 162.513 128.957 162.92 127.999 163.485 127.643 C 163.984 127.278 164.512 127.15 165.216 127.25 C 165.78 125.279 167.011 123.536 168.918 122.286 C 170.779 121.008 173.315 119.949 176.508 119.392 C 175.916 118.708 174.842 118.443 173.315 118.735 C 171.75 118.936 168.983 119.593 167.215 120.844 C 165.345 122.085 163.318 124.385 162.281 125.963 C 161.217 127.414 160.68 128.628 160.819 129.614 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path249",
    strokeLinejoin: "round",
    d: "M 167.085 127.25 C 167.048 125.9 167.881 124.686 169.714 123.6 C 171.482 122.322 174.944 120.971 177.943 120.579 C 180.877 120.214 184.108 120.606 187.505 121.628 C 183.376 121.099 179.877 121.364 177.008 122.286 C 174.083 123.235 171.778 124.85 170.112 127.25 L 167.085 127.25 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path251",
    strokeLinejoin: "round",
    d: "M 173.176 126.493 C 173.879 125.471 174.944 124.686 176.508 124.129 C 178.045 123.536 180.507 122.979 182.478 122.815 C 184.413 122.55 186.172 122.55 187.912 122.678 C 189.476 122.742 190.809 122.879 191.911 123.207 C 190.744 123.6 189.939 123.992 189.374 124.257 C 188.773 124.521 188.504 124.786 188.578 124.914 C 187.375 124.95 186.144 125.343 184.876 125.963 C 183.58 126.557 182.247 127.506 180.877 128.692 C 180.081 127.834 179.276 127.314 178.341 127.113 C 177.313 126.849 176.342 127.414 175.444 127.378 C 174.509 127.25 173.879 126.949 173.176 126.493 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path253",
    strokeLinejoin: "round",
    d: "M 184.876 128.957 C 187.745 128.263 189.374 127.999 189.911 128.163 C 190.337 128.236 188.773 128.92 187.773 129.614 C 186.672 130.234 185.477 131.028 183.811 131.978 C 183.747 131.421 183.747 130.892 183.941 130.399 C 184.145 129.906 184.413 129.386 184.876 128.957 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path255",
    strokeLinejoin: "round",
    d: "M 185.274 132.105 C 186.709 131.585 188.078 131.193 189.374 131.056 C 190.642 130.828 191.837 130.828 192.975 131.056 C 191.439 131.686 190.244 132.47 189.504 133.292 C 188.643 134.113 187.94 135.327 188.31 135.92 C 188.606 136.413 189.671 136.541 191.503 136.313 L 188.171 138.777 L 186.079 138.12 C 185.246 137.271 184.839 136.577 184.876 135.92 C 184.913 135.3 185.913 134.77 186.079 134.214 C 186.144 133.556 185.875 132.899 185.274 132.105 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path257",
    strokeLinejoin: "round",
    d: "M 170.917 139.041 C 170.381 139.963 170.945 141.442 171.445 142.591 C 171.88 143.677 172.38 144.891 173.713 145.348 C 175.009 145.649 178.11 145.977 179.146 144.69 C 180.081 143.312 180.211 138.585 179.415 137.335 C 178.508 136.084 175.981 136.842 174.509 137.198 C 173.046 137.462 171.38 138.12 170.917 139.041 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(0, 253, 245)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path259",
    strokeLinejoin: "round",
    d: "M 163.485 140.483 C 162.346 140.52 160.985 140.912 160.152 141.542 C 159.255 142.126 158.588 142.619 158.421 143.769 C 158.218 144.855 158.347 146.799 158.949 147.812 C 159.384 148.733 160.319 149.263 161.346 149.263 C 162.42 149.098 164.086 147.976 165.086 147.155 C 165.947 146.269 166.484 145.32 166.678 144.298 C 166.882 143.249 166.752 141.606 166.28 141.013 C 165.614 140.319 164.549 140.356 163.485 140.483 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(0, 253, 245)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path261",
    strokeLinejoin: "round",
    d: "M 178.48 191.116 C 178.248 189.573 178.248 188.424 178.748 187.301 C 179.211 186.224 180.007 184.974 181.146 184.709 C 182.173 184.417 184.274 184.508 184.746 185.494 C 185.042 186.452 184.644 187.931 183.274 190.194 C 184.441 189.637 185.339 189.637 186.338 190.331 C 187.31 190.988 189.041 192.759 188.837 194.137 C 188.477 195.423 187.107 196.765 184.478 198.18 C 185.274 199.594 185.672 200.771 185.542 201.857 C 185.339 202.907 184.543 204.422 183.673 204.486 C 182.812 204.422 181.608 203.5 180.211 201.73 C 179.341 203.637 178.582 204.687 177.545 205.015 C 176.48 205.243 174.777 204.13 174.25 203.436 C 173.611 202.551 173.916 201.365 174.25 200.415 C 174.509 199.494 175.175 198.709 176.11 198.052 C 174.083 196.573 172.75 195.387 171.982 194.137 C 171.214 192.886 171.084 191.545 171.584 190.851 C 172.111 190.094 173.648 189.537 174.916 189.674 C 176.082 189.738 177.175 190.13 178.48 191.116 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path263",
    strokeLinejoin: "round",
    d: "M 179.674 193.352 C 179.609 191.736 179.748 190.294 179.942 189.145 C 180.146 187.931 180.174 186.553 180.942 186.251 C 181.581 185.823 183.747 185.923 183.978 186.909 C 184.172 187.867 183.413 189.573 181.942 192.038 C 183.312 190.952 184.311 190.659 185.311 191.015 C 186.209 191.38 187.773 193.124 187.44 194.2 C 186.977 195.159 185.709 196.044 183.145 196.865 C 184.108 198.444 184.607 199.694 184.644 200.744 C 184.543 201.757 183.839 203.044 183.08 202.943 C 182.312 202.743 181.312 201.593 180.081 199.621 C 179.415 201.958 178.609 203.235 177.813 203.829 C 176.915 204.358 175.342 203.208 175.046 202.779 C 174.648 202.222 175.342 201.401 175.842 200.68 C 176.342 199.886 176.878 199.101 177.813 198.18 C 175.546 196.601 174.009 195.323 173.213 194.2 C 172.38 193.051 172.343 192.001 172.843 191.444 C 173.278 190.751 174.481 190.13 175.675 190.459 C 176.777 190.751 178.11 191.672 179.674 193.352 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(244, 111, 144)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path265",
    strokeLinejoin: "round",
    d: "M 162.485 198.28 C 162.18 199.494 161.615 200.516 160.921 201.2 C 160.152 201.857 158.949 202.578 158.088 202.487 C 157.116 202.286 155.45 201.501 155.515 200.607 C 155.487 199.758 156.552 198.672 158.347 197.358 C 157.283 197.459 156.45 197.03 155.987 196.208 C 155.45 195.387 154.589 193.151 155.321 192.302 C 156.052 191.317 157.653 190.787 160.254 190.586 C 160.051 189.145 160.254 188.095 160.717 187.301 C 161.152 186.452 162.383 185.494 163.114 185.859 C 163.846 186.188 164.318 187.274 164.882 189.245 C 166.15 187.958 167.252 187.401 168.178 187.566 C 169.112 187.666 169.983 189.145 170.251 189.966 C 170.316 190.687 169.779 191.736 169.177 192.366 C 168.585 192.886 167.844 193.416 166.845 193.58 C 167.918 195.423 168.548 196.902 168.751 198.143 C 168.946 199.393 168.446 200.352 167.881 200.872 C 167.178 201.173 165.678 201.1 164.818 200.68 C 163.883 200.215 163.151 199.457 162.485 198.28 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path267",
    strokeLinejoin: "round",
    d: "M 162.513 196.272 C 161.92 197.522 161.346 198.608 160.819 199.53 C 160.18 200.315 159.616 201.401 158.986 201.501 C 158.255 201.428 156.589 200.771 156.82 199.923 C 157.052 199.065 158.153 197.979 160.254 196.537 C 158.82 196.966 157.755 196.728 157.181 196.208 C 156.552 195.551 155.95 193.607 156.654 192.923 C 157.255 192.202 158.755 192.065 161.013 192.266 C 160.754 190.723 160.819 189.409 161.217 188.679 C 161.587 187.83 162.652 187.009 163.253 187.465 C 163.781 187.894 164.179 189.081 164.447 191.143 C 165.715 189.537 166.845 188.679 167.715 188.579 C 168.585 188.487 169.381 189.765 169.585 190.386 C 169.585 190.815 168.816 191.28 168.178 191.773 C 167.548 192.165 166.678 192.594 165.715 193.051 C 167.011 195.022 167.65 196.665 167.983 197.851 C 168.178 199.028 167.78 199.749 167.28 200.151 C 166.65 200.507 165.484 200.58 164.679 199.987 C 163.883 199.266 163.114 198.143 162.513 196.272 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(110, 117, 243)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path269",
    strokeLinejoin: "round",
    d: "M 152.09 215.227 C 150.424 212.864 149.822 210.956 150.285 209.642 C 150.683 208.328 152.155 207.479 154.682 207.215 C 154.821 204.093 155.589 202.615 156.987 202.651 C 158.384 202.651 160.217 204.258 162.846 207.479 C 164.549 204.814 166.086 203.601 167.585 203.701 C 169.011 203.701 171.251 206.001 171.445 207.935 C 171.584 209.879 170.482 212.143 168.279 215.1 C 162.883 215.136 157.487 215.163 152.09 215.227 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path271",
    strokeLinejoin: "round",
    d: "M 153.951 214.443 C 152.423 212.9 151.618 211.851 151.553 210.929 C 151.387 209.971 152.423 209.222 153.349 209.186 C 154.284 209.149 155.487 209.679 157.089 210.765 C 156.218 208.136 156.089 206.594 156.681 206.001 C 157.255 205.444 159.514 206.357 160.384 207.379 C 161.05 208.301 161.421 209.578 161.115 211.358 C 163.448 208.164 165.216 206.457 166.548 205.964 C 167.78 205.535 169.011 207.05 168.946 208.593 C 168.816 210.044 167.844 211.942 165.919 214.443 L 153.951 214.443 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(247, 162, 134)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path273",
    strokeLinejoin: "round",
    d: "M 190.143 206.065 C 189.541 204.358 188.606 203.044 187.477 201.857 C 186.246 200.68 184.172 198.572 183.21 199.101 C 182.247 199.494 181.71 201.337 181.747 204.486 C 180.479 203.564 179.378 203.308 178.443 203.564 C 177.48 203.893 175.916 204.979 176.045 206.065 C 176.11 207.087 176.915 207.999 178.711 209.314 C 179.174 209.286 179.174 209.286 178.711 209.314 C 178.11 209.25 176.443 209.085 175.777 209.45 C 175.11 209.779 174.675 210.6 174.842 211.549 C 174.981 212.371 175.342 213.585 176.314 214.835 L 188.004 214.835 C 188.708 211.915 189.411 208.985 190.143 206.065 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path275",
    strokeLinejoin: "round",
    d: "M 188.81 206.457 L 187.208 213.521 L 177.647 213.913 C 177.11 212.9 176.98 212.106 176.98 211.549 C 176.98 210.892 176.943 210.628 177.776 210.372 C 178.48 210.044 179.711 209.907 181.479 209.843 C 179.581 208.821 178.313 207.872 178.045 206.986 C 177.674 206.001 178.508 204.623 179.378 204.486 C 180.109 204.358 181.34 205.015 182.812 206.329 C 182.71 204.221 182.978 202.779 183.478 202.122 C 183.941 201.465 184.913 201.465 185.875 202.25 C 186.773 203.007 187.708 204.294 188.81 206.457 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(192, 131, 243)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path277",
    strokeLinejoin: "round",
    d: "M 192.605 160.196 C 193.308 161.118 194.243 161.775 195.409 162.432 C 196.539 162.961 197.909 163.481 199.501 163.746 C 199.908 159.703 200.834 155.341 202.574 150.641 C 204.24 145.813 207.137 139.99 209.47 135.464 C 211.663 130.828 213.968 126.1 215.866 123.536 C 217.532 120.907 218.596 121.199 220.364 120.113 C 222.16 118.9 225.492 117.978 226.76 116.865 C 227.862 115.715 227.862 113.78 227.297 113.314 C 226.659 112.721 224.863 113.314 223.16 113.707 C 221.364 114.136 217.236 116.271 216.93 115.678 C 216.597 114.994 219.901 111.407 221.429 109.509 C 222.826 107.437 225.233 104.973 225.566 103.759 C 225.798 102.409 224.696 101.587 223.298 102.18 C 221.864 102.837 218.828 105.429 217.43 107.437 C 215.931 109.271 215.403 112.922 214.801 113.314 C 214.135 113.616 213.265 111.836 213.737 109.372 C 214.163 106.78 216.403 100.994 217.328 98.104 C 218.161 95.048 218.467 92.486 218.365 91.696 C 218.096 90.875 217.134 91.532 215.995 93.405 C 214.829 95.244 212.469 101.423 211.469 102.573 C 210.405 103.495 210.034 102.436 209.868 99.811 C 209.534 97.084 210.571 88.838 210.136 86.998 C 209.599 85.257 207.905 86.669 207.202 89.068 C 206.471 91.4 206.165 96.131 205.767 100.731 C 205.267 105.302 204.869 110.157 204.434 115.943 C 203.101 113.971 201.907 112.393 200.972 111.078 C 200.001 109.7 199.204 108.487 198.575 108.185 C 197.742 107.857 196.603 108.122 196.474 109.372 C 196.27 110.522 196.705 113.543 197.77 115.286 C 198.742 116.892 200.334 118.243 202.574 119.329 C 202.139 122.149 201.204 126.913 199.501 133.748 C 197.835 140.62 195.539 149.263 192.605 160.196 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path279",
    strokeLinejoin: "round",
    d: "M 206.832 122.349 C 206.239 123.6 205.832 125.179 205.499 127.086 C 205.166 128.893 205.036 131.028 204.971 133.493 C 203.703 133.164 202.907 132.534 202.703 131.12 C 202.407 129.641 202.805 126.885 203.499 125.37 C 204.203 123.892 205.267 122.842 206.832 122.349 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path281",
    strokeLinejoin: "round",
    d: "M 407.905 300.649 C 403.305 299.271 401.407 297.565 401.805 295.392 C 402.203 293.193 405.174 290.565 410.571 287.507 C 410.636 282.972 411.339 280.316 412.672 279.394 C 413.968 278.445 415.838 279.358 418.402 282.022 C 417.606 278.345 417.837 275.716 419.364 274.137 C 420.864 272.531 425.066 271.117 427.195 272.431 C 429.231 273.681 431.027 278.281 431.564 281.657 C 431.962 285.016 431.397 288.365 429.861 292.207 C 430.296 297.3 429.694 301.443 427.935 304.628 C 426.103 307.85 423.363 309.912 419.364 311.199 C 417.763 314.649 415.736 316.356 413.274 316.456 C 410.765 316.483 405.267 314.183 404.471 311.592 C 403.601 308.863 404.702 305.349 407.905 300.649 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path283",
    strokeLinejoin: "round",
    d: "M 411.172 300.093 C 405.804 298.286 403.434 296.643 403.703 295.037 C 404.073 293.394 407.072 291.879 413.07 290.501 C 411.867 285.244 411.931 282.223 413.264 281.302 C 414.597 280.343 417.096 281.594 420.901 285.043 C 419.596 280.015 419.466 276.866 420.503 275.087 C 421.53 273.353 425.362 273.088 427.001 274.694 C 428.565 276.309 429.5 281.53 429.666 284.286 C 429.629 286.987 428.898 288.885 427.195 290.501 C 428.093 296.707 427.732 301.179 426.232 304.035 C 424.668 306.828 421.863 308.014 417.837 307.448 C 417.837 311.163 417.133 313.234 415.366 313.663 C 413.598 313.955 408.173 312.148 407.535 309.885 C 406.841 307.585 408.007 304.364 411.172 300.093 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(167, 160, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path285",
    strokeLinejoin: "round",
    d: "M 417.633 325.327 C 417.004 322.963 417.004 320.928 417.633 319.477 C 418.17 317.898 419.799 316.456 421.262 316.292 C 422.669 316.063 424.363 316.684 426.232 318.163 C 428.565 317.076 430.527 316.912 432.129 317.807 C 433.665 318.655 435.165 320.435 435.59 323.255 C 435.831 325.984 434.896 332.025 434.063 334.161 C 433.23 336.105 431.925 336.561 430.425 335.283 C 430.731 338.468 430.231 341.161 428.528 343.004 C 426.732 344.875 422.169 347.503 420.503 346.582 C 418.864 345.532 418.402 342.511 418.966 337.154 C 412.931 336.625 409.867 335.384 409.636 333.412 C 409.367 331.441 412.033 328.74 417.633 325.327 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path287",
    strokeLinejoin: "round",
    d: "M 418.929 325.619 C 418.402 323.547 418.402 322.078 418.929 320.791 C 419.466 319.44 420.605 318.391 421.928 318.163 C 423.067 318.035 424.427 318.427 426.029 319.705 C 428 318.783 429.629 318.692 430.925 319.413 C 432.193 320.17 433.397 321.548 433.758 323.912 C 434.026 326.111 433.1 331.24 432.499 332.947 C 431.758 334.626 430.759 334.891 429.5 333.869 C 429.565 337.218 429.028 339.719 427.76 341.489 C 426.501 343.168 423.27 345.331 422.03 344.318 C 420.734 343.269 420.068 340.339 420.031 335.411 C 415.032 334.955 412.505 333.969 412.302 332.326 C 412.135 330.647 414.301 328.411 418.929 325.619 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(167, 160, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path289",
    strokeLinejoin: "round",
    d: "M 128.357 162.003 C 128.061 162.697 128.191 163.253 128.764 163.682 C 129.227 164.047 130.764 164.796 131.56 164.567 C 132.328 164.339 132.958 163.554 133.457 162.332 C 133.828 163.618 134.457 164.212 135.494 163.974 C 136.521 163.746 137.789 162.76 139.557 161.017 C 139.354 161.583 139.659 162.14 140.187 162.432 C 140.659 162.66 141.853 163.418 142.89 162.925 C 143.926 162.405 144.889 161.218 146.157 159.375 C 142.353 159.347 138.993 159.448 136.058 159.94 C 133.059 160.36 130.495 161.054 128.357 162.003 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path291",
    d: "M 130.329 160.132 C 129.996 160.525 129.792 161.118 129.727 161.547 C 129.523 162.003 129.459 162.733 129.792 162.961 C 130.097 163.126 130.958 163.089 131.625 162.596 C 132.189 162.003 132.726 161.017 133.226 159.512 C 132.263 159.703 131.291 159.904 130.329 160.132 Z",
    fillRule: "evenodd",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path293",
    d: "M 135.429 158.918 C 135.188 159.411 135.022 159.968 135.059 160.461 C 135.022 160.99 135.022 161.611 135.429 161.939 C 135.688 162.14 136.355 162.304 137.058 161.674 C 137.762 161.054 138.521 159.804 139.492 158.06 C 138.16 158.325 136.79 158.626 135.429 158.918 Z",
    fillRule: "evenodd",
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path295",
    d: "M 141.825 157.997 C 141.455 158.489 141.288 159.183 141.186 159.703 C 141.094 160.269 141.02 161.182 141.353 161.446 C 141.52 161.483 142.491 161.154 142.991 160.598 C 143.593 160.068 144.019 159.083 144.657 157.997 L 141.825 157.997 Z",
    fillRule: "evenodd",
    style: {
      fill: "rgb(241, 207, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path297",
    strokeLinejoin: "round",
    d: "M 332.198 237.669 C 332.198 244.012 334.031 249.141 336.225 249.141 C 338.455 249.141 340.26 244.012 340.26 237.669 C 340.26 231.326 338.455 226.206 336.225 226.206 C 334.031 226.206 332.198 231.326 332.198 237.669 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path299",
    strokeLinejoin: "round",
    d: "M 448.66 215.985 C 446.624 215.921 445.189 216.514 444.226 217.628 C 443.227 218.814 442.755 220.749 442.829 222.693 C 442.829 224.5 443.292 226.471 444.226 228.606 L 443.662 234.484 C 444.023 236.419 444.921 237.897 446.726 239.275 C 448.42 240.662 451.391 242.469 453.955 242.305 C 456.454 241.903 459.388 239.54 461.85 237.377 C 464.118 235.141 465.22 231.591 468.117 229.264 C 471.051 226.863 474.717 224.856 479.382 223.112 C 480.613 224.691 481.909 225.741 483.417 226.398 C 484.815 226.964 488.018 227.219 488.147 226.799 C 488.249 226.234 484.843 225.02 484.112 223.514 C 483.343 221.935 483.112 220.064 483.547 217.628 C 484.815 216.514 486.111 215.1 487.583 213.256 C 489.045 211.321 491.313 209.122 492.183 206.658 C 492.84 204.057 492.914 201.365 492.007 198.18 C 493.34 196.409 493.442 194.931 492.442 193.251 C 491.415 191.545 488.508 188.716 485.907 188.451 C 483.177 188.195 478.317 190.167 476.577 191.572 C 474.846 192.822 474.346 194.337 475.346 196.108 C 474.217 196.336 473.513 196.409 473.245 196.665 C 472.884 196.902 472.986 196.966 473.411 197.23 C 472.051 197.194 471.282 197.322 470.755 197.751 C 470.181 198.116 470.218 198.709 470.486 199.53 L 468.385 200.087 C 466.988 198.508 465.553 197.559 463.952 197.358 C 462.221 196.993 459.953 197.522 458.824 198.572 C 457.722 199.594 457.259 201.501 457.417 203.929 C 456.019 202.715 454.584 202.122 452.992 202.414 C 451.354 202.615 449.725 205.773 447.688 205.307 C 445.522 204.787 442.125 200.607 440.33 199.53 C 438.46 198.408 436.498 197.586 436.859 198.709 C 437.229 199.786 440.524 204.029 442.255 205.836 C 443.828 207.479 444.958 208.529 446.42 208.857 C 447.79 209.222 449.058 208.1 450.761 207.908 C 452.39 207.58 454.418 207.342 456.584 207.087 C 456.556 209.779 456.186 211.714 455.621 213.265 C 454.991 214.707 454.158 215.364 452.992 215.857 C 451.789 216.313 450.391 216.313 448.66 215.985 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path301",
    strokeLinejoin: "round",
    d: "M 454.353 204.057 C 453.122 204.258 451.928 204.623 450.761 205.015 C 449.623 205.344 448.762 206.986 447.253 206.393 C 445.559 205.672 441.857 201.529 441.163 201.337 C 440.431 201.2 442.329 204.13 443.255 205.307 C 444.162 206.293 445.06 207.58 446.596 207.771 C 448.022 207.972 450.123 206.621 451.992 206.521 C 453.788 206.293 455.556 206.293 457.426 206.521 L 457.157 204.878 C 456.223 204.623 455.288 204.358 454.353 204.057 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path303",
    strokeLinejoin: "round",
    d: "M 475.485 210.372 C 476.614 211.522 477.281 212.8 477.845 214.342 C 478.317 215.821 477.947 217.892 478.41 219.27 C 478.78 220.521 479.243 221.013 480.215 221.999 C 481.048 222.948 482.242 223.87 483.677 224.892 C 482.779 223.313 482.177 221.671 481.612 219.964 C 481.177 218.057 480.844 215.884 480.483 214.342 C 479.882 212.736 479.28 211.449 478.41 210.765 C 477.614 210.071 476.549 209.943 475.485 210.372 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path305",
    strokeLinejoin: "round",
    d: "M 469.079 200.908 C 469.32 200.68 472.245 202.514 473.115 203.372 C 473.68 204.093 473.652 204.951 473.411 205.307 C 473.18 205.608 472.717 205.508 472.014 204.878 C 471.282 204.093 468.848 201.173 469.079 200.908 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path307",
    strokeLinejoin: "round",
    d: "M 472.412 199.129 C 472.486 198.873 475.883 200.479 476.447 201.036 C 476.947 201.593 476.281 202.487 475.614 202.286 C 474.911 201.958 472.217 199.266 472.412 199.129 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path309",
    strokeLinejoin: "round",
    d: "M 475.078 196.665 C 475.152 196.5 478.678 198.344 479.382 199.001 C 479.919 199.494 479.678 200.315 478.947 199.95 C 478.151 199.494 475.013 196.801 475.078 196.665 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path311",
    strokeLinejoin: "round",
    d: "M 475.346 206.393 C 475.883 205.9 476.244 205.535 476.447 205.307 C 476.651 205.042 476.484 204.814 476.318 204.75 C 477.012 205.042 477.614 204.878 477.845 204.623 C 478.077 204.194 478.077 203.664 477.845 202.679 C 478.613 203.537 479.317 203.637 479.946 202.98 C 480.511 202.186 481.316 199.786 481.446 198.572 C 481.409 197.395 480.909 196.309 480.215 195.843 C 479.409 195.286 478.512 195.058 477.151 195.286 C 478.317 193.644 479.743 192.594 481.316 191.873 C 482.779 191.079 484.982 190.851 486.481 191.18 C 488.009 191.572 489.776 192.494 490.341 194.073 C 490.813 195.487 490.878 196.902 489.378 199.694 C 487.777 202.451 485.047 205.8 481.048 210.235 C 480.011 209.122 479.076 208.301 478.114 207.643 C 477.179 207.014 476.216 206.557 475.346 206.393 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(238, 5, 5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path313",
    strokeLinejoin: "round",
    d: "M 469.515 207.215 C 470.551 208.401 471.782 209.514 472.847 210.929 C 473.883 212.27 475.115 213.685 476.179 215.3 C 473.717 216.843 471.347 218.814 468.82 221.47 C 466.247 224.071 463.748 228.835 461.184 230.934 C 458.518 232.969 455.917 234.091 453.39 233.535 C 450.724 232.841 447.327 229.391 445.893 227.219 C 444.495 224.919 444.726 221.835 444.921 220.356 C 444.893 218.878 445.393 218.285 446.42 218.449 C 447.494 218.65 449.021 220.584 451.159 221.47 C 453.224 222.2 456.584 224.007 458.953 222.985 C 461.221 221.835 463.118 217.929 464.914 215.3 C 466.719 212.636 468.117 209.943 469.515 207.215 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(238, 5, 5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path315",
    strokeLinejoin: "round",
    d: "M 467.552 205.015 C 466.821 202.615 465.849 200.972 464.655 200.215 C 463.35 199.457 461.054 199.293 460.184 200.352 C 459.249 201.301 458.851 204.358 459.351 205.964 C 459.888 207.443 461.517 208.593 462.85 209.414 C 463.989 210.235 465.053 210.6 466.182 210.765 C 466.617 208.857 467.08 206.95 467.552 205.015 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path317",
    strokeLinejoin: "round",
    d: "M 445.458 229.556 C 446.827 232.22 448.327 233.954 450.326 234.913 C 452.326 235.834 454.89 235.661 456.991 235.168 C 458.888 234.612 459.953 233.297 461.85 231.591 C 463.72 229.747 465.719 226.927 468.117 224.627 C 470.449 222.264 473.05 219.927 475.92 217.628 C 475.679 219.371 475.679 220.648 475.92 221.47 C 476.049 222.264 476.41 222.492 477.012 222.291 C 473.717 223.669 470.986 225.312 468.82 227.092 C 466.59 228.899 465.821 230.733 463.822 232.969 C 461.684 235.077 458.888 238.883 456.593 240.096 C 454.158 241.119 452.02 240.827 450.058 239.969 C 448.16 239.083 446.494 237.605 445.189 235.168 C 445.254 233.297 445.356 231.426 445.458 229.556 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path319",
    strokeLinejoin: "round",
    d: "M 482.575 212.572 C 483.084 211.778 484.047 210.4 485.482 208.301 C 486.907 206.128 488.814 203.473 491.174 199.95 C 492.479 201.401 492.313 203.5 491.045 206.128 C 489.675 208.757 487.046 211.915 483.149 215.72 C 482.982 214.671 482.779 213.621 482.575 212.572 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path321",
    strokeLinejoin: "round",
    d: "M 411.274 95.475 C 406.803 94.884 403.406 93.701 400.944 91.796 C 398.436 89.791 396.742 87.229 396.344 84.108 C 395.807 80.921 396.344 77.438 397.945 73.266 C 401.87 73.036 405.572 73.627 409.173 75.171 C 412.737 76.65 416.171 78.982 419.466 82.169 C 419.697 76.091 420.938 71.656 422.9 68.863 C 424.899 65.972 428.796 65.249 431.397 65.315 C 433.859 65.348 435.433 67.22 437.766 69.159 C 440.024 71.064 442.56 73.397 445.226 76.518 C 446.096 73.101 447.327 70.999 448.79 70.473 C 450.354 69.882 453.427 71.491 453.992 73.003 C 454.325 74.448 453.353 76.452 450.956 79.147 C 454.223 81.512 456.491 84.075 458.259 87.327 C 459.953 90.449 462.591 92.715 460.888 98.038 C 458.953 103.33 454.519 110.093 447.188 118.735 C 442.431 117.093 437.96 114.793 433.434 111.973 C 428.898 108.979 424.066 104.252 420.373 101.459 C 416.671 98.695 413.635 96.658 411.274 95.475 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path323",
    strokeLinejoin: "round",
    d: "M 421.364 97.184 C 421.095 92.486 420.262 88.609 418.864 85.685 C 417.439 82.629 415.504 81.151 412.672 79.344 C 409.673 77.438 405.841 76.124 401.037 74.908 C 403.369 80.691 406.174 85.29 409.571 89.101 C 412.931 92.814 416.865 95.508 421.364 97.184 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(242, 238, 13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path325",
    strokeLinejoin: "round",
    d: "M 398.741 76.748 C 397.538 78.719 397.01 80.789 397.14 82.826 C 397.14 84.83 397.603 87.459 399.436 89.069 C 401.37 90.679 404.202 91.598 408.433 92.223 C 406.803 90.481 405.239 88.182 403.74 85.323 C 402.175 82.399 400.805 78.917 399.371 74.875 L 398.741 76.748 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path327",
    strokeLinejoin: "round",
    d: "M 424.798 98.596 C 424.335 97.085 423.835 95.475 423.428 93.373 C 423.002 91.303 422.53 88.872 422.169 86.21 C 425.297 89.594 428.093 91.27 430.564 91.237 C 432.999 91.106 436.46 88.74 436.831 85.915 C 436.997 82.925 434.23 76.354 432.129 74.054 C 430.027 71.787 427.362 71.295 424.261 72.444 C 426.232 69.553 428.361 68.107 430.666 67.976 C 432.962 67.779 435.331 69.652 437.895 71.689 C 440.459 73.791 443.06 76.485 445.957 80.264 C 446.328 84.929 445.994 89.529 444.689 94.194 C 443.366 98.794 441.329 103.431 438.33 108.094 C 435.396 105.566 432.962 103.723 430.666 102.08 C 428.334 100.469 426.501 99.352 424.798 98.596 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(244, 240, 14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path329",
    strokeLinejoin: "round",
    d: "M 449.854 80.625 C 454.084 83.023 456.824 85.882 457.916 89.2 C 458.953 92.453 458.453 96.001 456.556 100.338 C 454.621 104.581 451.252 109.372 446.457 114.729 L 441.255 109.144 C 445.087 104.772 447.79 100.272 449.225 95.508 C 450.66 90.679 450.826 85.849 449.854 80.625 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(244, 240, 14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path331",
    strokeLinejoin: "round",
    d: "M 449.058 77.175 C 450.623 76.255 451.52 75.434 451.752 74.58 C 451.928 73.627 450.891 71.656 450.188 72.083 C 449.419 72.51 448.521 74.153 447.355 77.142 C 447.92 77.142 448.494 77.142 449.058 77.175 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path333",
    strokeLinejoin: "round",
    d: "M 425.631 74.317 C 426.834 74.81 429.5 76.42 430.796 78.522 C 432.064 80.526 433.128 84.699 432.832 86.342 C 432.332 87.787 429.629 88.313 428.065 87.787 C 426.334 87.097 424.002 85.192 423.261 83.089 C 422.53 80.954 423.233 77.175 423.696 75.664 C 424.029 74.153 424.464 73.824 425.631 74.317 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    fill: "#fff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path335",
    strokeLinejoin: "round",
    d: "M 401.176 142.327 C 409.534 144.727 416.069 147.291 420.901 150.011 C 425.631 152.712 428.13 155.834 430.064 158.626 C 431.897 161.382 433.026 166.411 432.193 166.247 C 431.296 165.818 429 159.74 425.029 156.883 C 420.929 154.027 412.866 151.097 408.405 149.263 C 404.008 147.355 400.778 146.205 398.704 145.676 C 399.51 144.563 400.343 143.44 401.176 142.327 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path337",
    strokeLinejoin: "round",
    d: "M 450.419 154.191 C 458.018 157.376 463.285 159.74 466.349 161.419 C 469.348 162.989 468.45 162.961 468.552 163.974 C 468.589 164.996 467.552 167.397 466.719 167.36 C 465.719 167.132 466.247 164.796 463.193 163.153 C 460.119 161.51 455.26 159.776 448.457 157.805 C 446.263 161.51 443.458 164.075 439.561 165.489 C 435.563 166.84 428.398 167.661 425.399 166.046 C 422.539 164.275 422.465 158.626 422.104 155.304 C 421.632 151.891 423.233 146.598 422.4 146.142 C 421.438 145.74 418.568 149.783 416.374 152.576 C 414.107 155.204 411.737 160.169 409.006 162.003 C 406.044 163.81 401.768 164.796 399.547 163.189 C 397.242 161.419 395.779 155.569 396.038 151.727 C 396.307 147.812 398.038 143.869 401.24 139.899 C 403.443 138.485 407.47 137.955 413.607 138.056 C 419.67 138.156 432.027 139.306 437.692 140.62 C 443.227 141.834 444.828 143.185 446.994 145.548 C 449.123 147.784 450.225 150.705 450.419 154.191 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "path339",
    strokeLinejoin: "round",
    d: "M 425.936 143.677 C 428.195 140.721 437.46 144.855 440.765 145.977 C 443.958 146.99 445.189 147.784 445.365 150.248 C 445.458 152.804 444.162 158.426 441.2 160.762 C 438.062 163.025 429.796 165.982 427.195 163.29 C 424.668 160.333 423.594 146.534 425.936 143.677 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(16, 237, 185)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path341",
    strokeLinejoin: "round",
    d: "M 417.235 144.663 C 416.763 146.698 413.533 150.705 411.135 153.534 C 408.636 156.253 405.137 161.154 402.971 160.99 C 400.741 160.725 398.269 155.368 398.269 152.284 C 398.343 149.025 400.574 144.006 403.175 142.126 C 405.674 140.191 410.7 140.812 413.135 141.213 C 415.467 141.505 417.439 142.655 417.235 144.663 Z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.036,
    style: {
      fill: "rgb(0, 217, 255)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgba(35, 11, 254, 0.83)",
      fontFamily: "Chiller",
      fontSize: "82.8269px",
      fontStyle: "italic",
      fontWeight: 700,
      lineHeight: "73.6239px",
      paintOrder: "stroke",
      stroke: "url(#gradient-1)",
      whiteSpace: "pre"
    },
    transform: "matrix(1.086597, 0, 0, 1.086604, 49.034374, 451.279846)"
  }, "ENJOY TRIP"));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5cd4096c309a119c67c99555849b6273.svg";
export { ForwardRef as ReactComponent };